<template>
  <div id="app" :style="storeState.cssProps">
    <!-- <template v-if="storeState.loading"> -->
    <template v-if="storeState.loading">
      <div class="tw-flex tw-justify-center">
        <div class="tw-pt-32">
          <v-progress-circular
            indeterminate
            :size="100"
            :width="8"
            color="primary"
          >
          </v-progress-circular>
        </div>
      </div>
    </template>
    <template v-if="storeState.cmdkActive">
      <v-row justify="center">
        <v-dialog
          v-model="storeState.cmdkActive"
          retain-focus
          scrollable
          max-width="600px"
          content-class="tw-fixed tw-mt-32 tw-top-0"
        >
          <v-card class="tw-overflow-scroll">
            <v-row
              class="cmdk-input"
              v-if="
                !storeState.cmdkForm &&
                !storeState.hideCmdkInputParents.includes(
                  storeState.cmdkParentCmd
                )
              "
            >
              <v-col cols="12" sm="12" md="12">
                <input
                  v-model="storeState.cmdkInput"
                  v-on:keyup="cmdkOnKey"
                  ref="cmdkInput"
                  :placeholder="cmdkPlaceholder"
                  class="cmdkInput mousetrap"
                />
              </v-col>
            </v-row>
            <div v-if="storeState.cmdkForm" class="tw-py-4">
              <div
                v-for="(field, index) in storeState.cmdkForm.params"
                v-bind:key="index"
                class="tw-px-4 tw-py-2"
              >
                <div>
                  <div
                    v-if="field.type === 'select'"
                    class="tw-mt-1 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                  >
                    <span
                      class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                    >
                      {{ field.label || field.name }}
                    </span>
                    <div class="tw-inline-flex tw-w-full">
                      <v-autocomplete
                        ref="source"
                        v-model="field.value"
                        :items="field.options"
                        :placeholder="field.value"
                        auto-select-first
                        single-line
                        dense
                        autocomplete="disabled"
                        class="tw-mt-3 tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                        :menu-props="{ contentClass: 'tw-mt-4 tw--ml-3' }"
                      >
                        <template v-slot:selection="{ item }">
                          <div class="">
                            {{ item }}
                          </div>
                        </template>
                        <template v-slot:item="{ item }">
                          <div>
                            {{ item }}
                          </div>
                        </template>
                        <template v-slot:no-data>
                          <div></div>
                        </template>
                        <template v-slot:append-item>
                          <div
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2"
                            @click="refreshParamOptions(field.blockId, index)"
                          >
                            Refresh
                          </div>
                          <div
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2"
                            @click="openBlock(field.blockId)"
                          >
                            View block
                          </div>
                        </template>
                      </v-autocomplete>
                      <div class="tw-inline-block"></div>
                    </div>
                  </div>
                  <div
                    v-if="field.type === 'value' || field.type === 'basic'"
                    class="tw-mt-1 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                  >
                    <span
                      class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                    >
                      {{ field.label || field.name }}
                    </span>
                    <input
                      v-if="index === 0"
                      class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                      v-model="field.value"
                      v-focus
                      @focus="$event.target.select()"
                    />
                    <input
                      v-else
                      class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                      v-model="field.value"
                    />
                  </div>
                </div>
              </div>
              <div class="tw-pt-4 tw-px-2">
                <div
                  class="tw-border-l-4 tw-ml-2 tw-border-gray-500 tw-pl-3 tw-whitespace-pre-wrap tw-font-mono"
                  v-html="renderedSnippet"
                ></div>
              </div>
              <div class="tw-pt-8">
                <v-tooltip left dark color="#333">
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer"
                      @click="doneWithSnippet"
                    >
                      Done
                    </span>
                  </template>
                  <span class="tooltip-text">Done</span>
                  <span class="key">
                    <span
                      v-if="storeState.isMac"
                      class="key-inner key-inner-icon"
                    >
                      <v-icon color="#fff !important" size="12"
                        >mdi-apple-keyboard-command</v-icon
                      >
                    </span>
                    <span v-else class="key-inner"> Ctrl </span>
                  </span>
                  <span class="key">
                    <span class="key-inner">enter</span>
                  </span>
                </v-tooltip>
              </div>
            </div>
            <!-- ADD BLUESHIFT DESTINATION -->
            <div
              v-else-if="storeState.cmdkParentCmd === 'addIntegration'"
              class="tw-bg-white tw-h-50vh tw-mx-4 tw-my-4 tw-overflow-scroll"
            >
              <div class="tw-text-3xl tw-font-bold">
                Add {{ storeState.pendingIntegration.app_name }}
              </div>
              <div
                v-if="storeState.pendingIntegration.app_name === 'Blueshift'"
              >
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Name
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.nickname"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    User Key
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.userKey"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Event Key
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.eventKey"
                  />
                </div>
              </div>
              <div
                v-if="storeState.pendingIntegration.app_name === 'Gainsight'"
              >
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Name
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.nickname"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    API Key
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.apiKey"
                  />
                </div>
              </div>
              <div v-if="storeState.pendingIntegration.app_name === 'Zendesk'">
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Domain name
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.domain"
                  />
                </div>
              </div>
              <div
                v-if="storeState.pendingIntegration.app_name === 'Customerio'"
              >
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Name
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.nickname"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Site ID
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.site_id"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    API key
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.apikey"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Bearer
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.bearertoken"
                  />
                </div>
              </div>
              <div v-if="storeState.pendingIntegration.app_name === 'Close'">
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Name
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.nickname"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    API Key
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.apiKey"
                  />
                </div>
              </div>
              <div
                v-if="
                  storeState.pendingIntegration.app_name === 'ActiveCampaign'
                "
              >
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    Name
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.nickname"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    URL
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.url"
                  />
                </div>
                <div
                  class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm"
                >
                  <span
                    class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                  >
                    KEY
                  </span>
                  <input
                    class="tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    v-focus
                    v-model="storeState.pendingIntegration.key"
                  />
                </div>
              </div>
              <div>
                <div class="tw-pt-8">
                  <span
                    class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer"
                    @click="doneAddingIntegration"
                  >
                    Done
                  </span>
                </div>
              </div>
            </div>
            <!-- END ADD BLUESHIFT -->
            <!-- AUTOEXPORT DATABASE TO SHEETS -->
            <div
              v-else-if="storeState.cmdkParentCmd === 'autoImportToSheets'"
              class="tw-bg-white tw-h-50vh tw-mx-4 tw-my-4 tw-overflow-scroll"
            >
              <div class="tw-text-3xl tw-font-bold">Import SQL to Sheets</div>
              <div
                class="tw-pt-4"
                v-if="!storeState.gotBlocks || !storeState.gotSheets"
              >
                <div class="tw-pt-0 tw-inline-block">
                  <v-progress-circular
                    indeterminate
                    :size="20"
                    :width="3"
                    color="primary"
                    class="tw-inline-block"
                  >
                  </v-progress-circular>
                </div>
                <div class="tw-align-text-top tw-inline-block tw-pl-4">
                  Getting Sheets...
                </div>
              </div>
              <div v-else>
                <div class="tw-mt-8 md:tw-grid md:tw-grid-cols-12 md:tw-gap-0">
                  <div class="tw-border-b tw-col-span-4 tw-mr-4 tw-mt-1">
                    <v-autocomplete
                      v-model="storeState.autoImport.source.uuid"
                      :items="dbDestinations"
                      placeholder="Source"
                      item-text="name"
                      item-value="block_uuid"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                      @change="onImportDbChange"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <!-- {{item.name}} -->
                          <v-list-item-title v-html="item.name">{{
                            item
                          }}</v-list-item-title>
                          <v-list-item-subtitle
                            v-html="item.db_type"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-slot:no-data>
                        <div></div>
                      </template>
                      <!-- <template v-slot:append-item>
                        <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="addSource">
                          Add database
                        </div>
                      </template> -->
                    </v-autocomplete>
                  </div>
                  <div class="tw-col-span-1">
                    <svg
                      class="tw-w-6 tw-h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      ></path>
                    </svg>
                  </div>
                  <div class="tw-border-b tw-col-span-4 tw-mr-4 tw-mt-1">
                    <v-autocomplete
                      ref="spreadSheets"
                      v-model="storeState.autoImport.ss_id"
                      :items="storeState.destinations.spreadSheets"
                      :search-input.sync="searchSpreadsheet"
                      placeholder="Spreadsheet"
                      item-text="name"
                      item-value="id"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                      @change="onSpreadSheetChange"
                    >
                      <template v-slot:no-data>
                        <div></div>
                      </template>
                      <template v-slot:append-item>
                        <div
                          v-if="!storeState.gotSheets"
                          class="tw-flex tw-justify-center"
                        >
                          <div class="tw-py-2">
                            <v-progress-circular
                              indeterminate
                              :size="30"
                              :width="4"
                              color="primary"
                            >
                            </v-progress-circular>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2"
                            @click="refreshSpreadSheets"
                          >
                            <div>Refresh Sheets</div>
                          </div>
                          <div
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2"
                            @click="newSpreadsheet"
                          >
                            Create new Sheet
                          </div>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                  <!-- <div class="tw-border-b tw-col-span-3 tw-mr-4 tw-mt-1">
                    <input placeholder="Schema (optional)" v-model="storeState.autoImport.schema" type="text">
                  </div> -->
                </div>
                <div>
                  <div
                    class="tw-mt-8"
                    v-if="
                      storeState.autoImport.ss_id &&
                      storeState.autoImport.gettingTables
                    "
                  >
                    Getting Database Schema...
                  </div>
                  <div
                    v-else-if="
                      storeState.autoImport.ss_id &&
                      !storeState.autoImport.source.uuid
                    "
                    class="tw-mt-8"
                  >
                    Select a destination database
                  </div>
                  <div v-else-if="storeState.autoImport.ss_id" class="tw-mt-8">
                    <!-- {{storeState.autoImport.spreadSheetMetadata}} -->
                    <div
                      class="md:tw-grid md:tw-grid-cols-12 md:tw-gap-2 tw-cursor-pointer tw-py-2"
                    >
                      <div
                        class="md:tw-col-span-2 tw-text-gray-900 tw-font-bold tw-ml-2"
                      >
                        Import
                      </div>
                      <div
                        class="md:tw-col-span-5 tw-text-gray-900 tw-font-bold tw-ml-2"
                      >
                        Table Name
                      </div>
                      <div
                        class="md:tw-col-span-4 tw-text-gray-900 tw-font-bold"
                      >
                        Sheet Name
                      </div>
                    </div>
                    <div
                      v-for="(source, index) in storeState.autoImport.tables"
                      :key="index"
                      class="md:tw-grid md:tw-grid-cols-12 md:tw-gap-2 tw-cursor-pointer tw-py-2"
                    >
                      <div
                        @click="includeSource(index, source)"
                        class="md:tw-col-span-2"
                        style="margin-top: 2px"
                      >
                        <button
                          type="button"
                          aria-pressed="true"
                          class="tw-relative tw-inline-flex tw-flex-shrink-0 tw-h-6 tw-w-11 tw-border-2 tw-border-transparent tw-rounded-full tw-cursor-pointer tw-transition-colors tw-ease-in-out tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-black"
                        >
                          <span class="tw-sr-only"></span>
                          <!-- On: "translate-x-5", Off: "translate-x-0" -->
                          <span
                            class="tw-translate-x-0 tw-relative tw-inline-block tw-h-6 tw-w-6 tw-rounded-full tw-bg-white tw-shadow tw-transform tw-ring-0 tw-transition tw-ease-in-out tw-duration-200"
                            :class="{ 'tw-translate-x-5': source.include }"
                          >
                            <!-- On: "opacity-0 ease-out duration-100", Off: "opacity-100 ease-in duration-200" -->
                            <span
                              class="tw-ease-in tw-duration-200 tw-absolute tw-inset-0 tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-transition-opacity"
                              aria-hidden="true"
                              :class="{
                                'tw-opacity-0': source.include,
                                'tw-opacity-100': !source.include,
                                'tw-ease-out': source.include,
                                'tw-duration-100': source.include,
                              }"
                            >
                              <svg
                                class="tw-h-3 tw-w-3 tw-text-gray-400"
                                fill="none"
                                viewBox="0 0 12 12"
                              >
                                <path
                                  d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </span>
                            <!-- On: "opacity-100 ease-in duration-200", Off: "opacity-0 ease-out duration-100" -->
                            <span
                              class="tw-opacity-0 tw-ease-out tw-duration-100 tw-absolute tw-inset-0 tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-transition-opacity"
                              aria-hidden="true"
                              :class="{
                                'tw-opacity-100': source.include,
                                'tw-ease-in': source.include,
                                'tw-duration-200': source.include,
                              }"
                            >
                              <svg
                                class="tw-h-3 tw-w-3 tw-text-black"
                                fill="currentColor"
                                viewBox="0 0 12 12"
                              >
                                <path
                                  d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                                ></path>
                              </svg>
                            </span>
                          </span>
                        </button>
                      </div>
                      <div
                        class="md:tw-col-span-5 tw-text-gray-900 tw-ml-2"
                        :class="{ 'tw-opacity-25': !source.include }"
                      >
                        <div @click="includeSource(index, source)">
                          {{ `${source.schema}.${source.name}` }}
                        </div>
                        <!-- <div v-if="storeState.autoImport.success && !source.success">
                          <input 
                            placeholder="Range (blank for entire Sheet)" 
                            v-model="source.range" 
                            type="text"
                          >
                        </div> -->
                      </div>
                      <div
                        class="md:tw-col-span-4 tw-text-gray-900"
                        :class="{ 'tw-opacity-25': !source.include }"
                      >
                        <div class="tw-border-b">
                          <input
                            placeholder="Sheet Name"
                            v-model="source.destName"
                            type="text"
                          />
                        </div>
                        <div
                          v-if="
                            source.success &&
                            storeState.autoImport.success &&
                            source.include
                          "
                          class="tw-cursor-default tw-flex tw-text-sm tw-text-gray-500 tw-font-medium"
                        >
                          <svg
                            class="tw-w-4 tw-h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style="margin-top: 3px; margin-right: 2px"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                            ></path>
                          </svg>
                          {{ source.message }}
                        </div>
                      </div>
                      <div
                        v-if="
                          !source.success &&
                          source.include &&
                          storeState.autoImport.success
                        "
                        class="md:tw-col-span-12 tw-text-gray-900 tw-cursor-default tw-mx-2"
                        :class="{ 'tw-text-red-600': !source.success }"
                      >
                        {{ source.message }}
                        <div>
                          <div
                            class="tw-pr-6 tw-font-bold tw-cursor-pointer tw-text-gray-900 hover:tw-text-gray-600"
                            @click="openBlock(source.blockId)"
                          >
                            Edit SQL
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tw-mt-8" v-if="storeState.autoImport.schedule">
                      <div class="tw-text-gray-900 tw-font-bold">
                        Repeat (Schedule)
                      </div>
                      <div class="tw-mt-2">
                        <div class="tw-mt-3 tw-cursor-pointer tw-inline-block">
                          <v-select
                            ref="repeatPeriod"
                            :items="intervals"
                            v-model="storeState.autoImport.repeat.period"
                            placeholder="Every"
                            single-line
                            dense
                            class="denser"
                          >
                            <template v-slot:selection="data">
                              <div
                                :data-type="data.item.value"
                                class="tw-cursor-pointer"
                              >
                                <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                                <span class="tw-pl-0">{{
                                  data.item.text
                                }}</span>
                              </div>
                            </template>
                            <template v-slot:item="data">
                              <div
                                :data-type="data.item.value"
                                class="tw-cursor-pointer"
                              >
                                <v-icon small>{{ data.item.icon }}</v-icon>
                                <span class="tw-pl-0">{{
                                  data.item.text
                                }}</span>
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <div class="tw-cursor-pointer tw-inline-block">
                          <v-text-field
                            ref="minutesPast"
                            v-if="
                              storeState.autoImport.repeat.period === 'hourly'
                            "
                            placeholder="Minutes past"
                            v-model="storeState.autoImport.repeat.minutesPast"
                            single-line
                            dense
                            class="denser"
                          ></v-text-field>
                          <div
                            v-if="
                              ['daily', 'weekly', 'monthly'].includes(
                                storeState.autoImport.repeat.period
                              )
                            "
                            class="tw-flex tw-inline-block"
                          >
                            <v-select
                              placeholder="Time"
                              :items="runTimes"
                              v-model="storeState.autoImport.repeat.runTime"
                              single-line
                              dense
                              class="denser"
                            ></v-select>
                            <a
                              id="utcTime"
                              href="https://www.google.com/search?q=utc+time+converter"
                              target="_blank"
                              >UTC</a
                            >
                          </div>
                        </div>
                        <div>
                          <div
                            v-if="
                              storeState.autoImport.repeat.period === 'weekly'
                            "
                            class="tw-cursor-pointer tw-inline-block"
                          >
                            <v-select
                              placeholder="Day"
                              :items="daysOfWeek"
                              v-model="storeState.autoImport.repeat.dayOfWeek"
                              single-line
                              dense
                              class="denser"
                            ></v-select>
                          </div>
                          <div
                            v-if="
                              storeState.autoImport.repeat.period === 'monthly'
                            "
                            class="tw-cursor-pointer tw-inline-block"
                          >
                            <v-text-field
                              ref="dayOfMonth"
                              placeholder="Day of month (e.g. 1)"
                              v-model="storeState.autoImport.repeat.dayOfMonth"
                              :rules="[fieldRules.isNum, fieldRules.required]"
                              hint="Use -1 for the last day of the month"
                              single-line
                              dense
                              class="denser"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tw-mt-8 tw-pb-12">
                      <span
                        v-if="
                          !storeState.autoImport.schedule &&
                          storeState.autoImport.success
                        "
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="storeState.autoImport.schedule = true"
                      >
                        Schedule Import
                      </span>
                      <span
                        v-if="storeState.autoImport.schedule"
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="saveImportScheduleDb"
                      >
                        Save Schedule
                      </span>
                      <span
                        v-if="!storeState.autoImport.running"
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="doneImportingDb"
                      >
                        Import
                        {{
                          storeState.autoImport.tables.filter((s) => s.include)
                            .length
                        }}
                        tables
                      </span>
                      <span v-else class="tw-float-right tw-mr-8">
                        <div class="tw-pt-0 tw-inline-block">
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="3"
                            color="primary"
                            class="tw-inline-block"
                          >
                          </v-progress-circular>
                        </div>
                      </span>
                      <span
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="cancelImport"
                      >
                        Cancel
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END AUTOEXPORT -->
            <!-- CREATE TABLE FROM SHEETS -->
            <div
              v-else-if="storeState.cmdkParentCmd === 'createTablesFromSheet'"
              class="tw-bg-white tw-h-50vh tw-mx-4 tw-my-4 tw-overflow-scroll"
            >
              <div class="tw-text-3xl tw-font-bold">Import Sheet to SQL</div>
              <div
                class="tw-pt-4"
                v-if="!storeState.gotBlocks || !storeState.gotSheets"
              >
                <div class="tw-pt-0 tw-inline-block">
                  <v-progress-circular
                    indeterminate
                    :size="20"
                    :width="3"
                    color="primary"
                    class="tw-inline-block"
                  >
                  </v-progress-circular>
                </div>
                <div class="tw-align-text-top tw-inline-block tw-pl-4">
                  Getting Sheets...
                </div>
              </div>
              <div v-else>
                <div class="tw-mt-8 md:tw-grid md:tw-grid-cols-12 md:tw-gap-0">
                  <div class="tw-border-b tw-col-span-4 tw-mr-4 tw-mt-1">
                    <v-autocomplete
                      ref="spreadSheets"
                      v-model="storeState.autoImport.ss_id"
                      :items="storeState.destinations.spreadSheets"
                      :search-input.sync="searchSpreadsheet"
                      placeholder="Spreadsheet"
                      item-text="name"
                      item-value="id"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                      @change="onSpreadSheetChange"
                    >
                      <template v-slot:no-data>
                        <div></div>
                      </template>
                      <template v-slot:append-item>
                        <div
                          v-if="!storeState.gotSheets"
                          class="tw-flex tw-justify-center"
                        >
                          <div class="tw-py-2">
                            <v-progress-circular
                              indeterminate
                              :size="30"
                              :width="4"
                              color="primary"
                            >
                            </v-progress-circular>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2"
                            @click="refreshSpreadSheets"
                          >
                            <div>Refresh Sheets</div>
                          </div>
                          <div
                            class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2"
                            @click="newSpreadsheet"
                          >
                            Create new Sheet
                          </div>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div class="tw-col-span-1">
                    <svg
                      class="tw-w-6 tw-h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      ></path>
                    </svg>
                  </div>
                  <div class="tw-border-b tw-col-span-4 tw-mr-4 tw-mt-1">
                    <v-autocomplete
                      v-model="storeState.autoImport.destination.uuid"
                      :items="dbDestinations"
                      placeholder="Destination"
                      item-text="name"
                      item-value="block_uuid"
                      auto-select-first
                      single-line
                      dense
                      autocomplete="off"
                      class="denser"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <!-- {{item.name}} -->
                          <v-list-item-title v-html="item.name">{{
                            item
                          }}</v-list-item-title>
                          <v-list-item-subtitle
                            v-html="item.db_type"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-slot:no-data>
                        <div></div>
                      </template>
                      <!-- <template v-slot:append-item>
                        <div class="hover:tw-bg-gray-100 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-2" @click="addSource">
                          Add database
                        </div>
                      </template> -->
                    </v-autocomplete>
                  </div>
                  <div class="tw-border-b tw-col-span-3 tw-mr-4 tw-mt-1">
                    <input
                      placeholder="Schema (optional)"
                      v-model="storeState.autoImport.schema"
                      type="text"
                    />
                  </div>
                </div>
                <div>
                  <div
                    class="tw-mt-8"
                    v-if="storeState.autoImport.ss_id && loadingSheets"
                  >
                    Loading Sheets...
                  </div>
                  <div
                    v-else-if="
                      storeState.autoImport.ss_id &&
                      !storeState.autoImport.destination.uuid
                    "
                    class="tw-mt-8"
                  >
                    Select a destination database
                  </div>
                  <div v-else-if="storeState.autoImport.ss_id" class="tw-mt-8">
                    <!-- {{storeState.autoImport.spreadSheetMetadata}} -->
                    <div
                      class="md:tw-grid md:tw-grid-cols-12 md:tw-gap-2 tw-cursor-pointer tw-py-2"
                    >
                      <div
                        class="md:tw-col-span-2 tw-text-gray-900 tw-font-bold tw-ml-2"
                      >
                        Import
                      </div>
                      <div
                        class="md:tw-col-span-5 tw-text-gray-900 tw-font-bold tw-ml-2"
                      >
                        Sheet Name (rows)
                      </div>
                      <div
                        class="md:tw-col-span-4 tw-text-gray-900 tw-font-bold"
                      >
                        Table Name
                      </div>
                    </div>
                    <div
                      v-for="(sheet, index) in storeState.autoImport
                        .spreadSheetMetadata.sheets"
                      :key="index"
                      class="md:tw-grid md:tw-grid-cols-12 md:tw-gap-2 tw-cursor-pointer tw-py-2"
                    >
                      <div
                        @click="includeSheet(index, sheet)"
                        class="md:tw-col-span-2"
                        style="margin-top: 2px"
                      >
                        <button
                          type="button"
                          aria-pressed="true"
                          class="tw-relative tw-inline-flex tw-flex-shrink-0 tw-h-6 tw-w-11 tw-border-2 tw-border-transparent tw-rounded-full tw-cursor-pointer tw-transition-colors tw-ease-in-out tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-black"
                        >
                          <span class="tw-sr-only"></span>
                          <!-- On: "translate-x-5", Off: "translate-x-0" -->
                          <span
                            class="tw-translate-x-0 tw-relative tw-inline-block tw-h-6 tw-w-6 tw-rounded-full tw-bg-white tw-shadow tw-transform tw-ring-0 tw-transition tw-ease-in-out tw-duration-200"
                            :class="{ 'tw-translate-x-5': sheet.include }"
                          >
                            <!-- On: "opacity-0 ease-out duration-100", Off: "opacity-100 ease-in duration-200" -->
                            <span
                              class="tw-ease-in tw-duration-200 tw-absolute tw-inset-0 tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-transition-opacity"
                              aria-hidden="true"
                              :class="{
                                'tw-opacity-0': sheet.include,
                                'tw-opacity-100': !sheet.include,
                                'tw-ease-out': sheet.include,
                                'tw-duration-100': sheet.include,
                              }"
                            >
                              <svg
                                class="tw-h-3 tw-w-3 tw-text-gray-400"
                                fill="none"
                                viewBox="0 0 12 12"
                              >
                                <path
                                  d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></path>
                              </svg>
                            </span>
                            <!-- On: "opacity-100 ease-in duration-200", Off: "opacity-0 ease-out duration-100" -->
                            <span
                              class="tw-opacity-0 tw-ease-out tw-duration-100 tw-absolute tw-inset-0 tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-transition-opacity"
                              aria-hidden="true"
                              :class="{
                                'tw-opacity-100': sheet.include,
                                'tw-ease-in': sheet.include,
                                'tw-duration-200': sheet.include,
                              }"
                            >
                              <svg
                                class="tw-h-3 tw-w-3 tw-text-black"
                                fill="currentColor"
                                viewBox="0 0 12 12"
                              >
                                <path
                                  d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
                                ></path>
                              </svg>
                            </span>
                          </span>
                        </button>
                      </div>
                      <div
                        class="md:tw-col-span-5 tw-text-gray-900 tw-ml-2"
                        :class="{ 'tw-opacity-25': !sheet.include }"
                      >
                        <div @click="includeSheet(index, sheet)">
                          {{ sheet.properties.title }} ({{
                            sheet.properties.gridProperties.rowCount
                          }})
                        </div>
                        <div
                          v-if="storeState.autoImport.success && !sheet.success"
                        >
                          <input
                            placeholder="Range (blank for entire Sheet)"
                            v-model="sheet.range"
                            type="text"
                          />
                        </div>
                      </div>
                      <div
                        class="md:tw-col-span-4 tw-text-gray-900"
                        :class="{ 'tw-opacity-25': !sheet.include }"
                      >
                        <div class="tw-border-b">
                          <input
                            placeholder="Table Name"
                            v-model="sheet.table"
                            type="text"
                          />
                        </div>

                        <div
                          v-if="
                            sheet.success &&
                            storeState.autoImport.success &&
                            sheet.include
                          "
                          class="tw-cursor-default tw-flex tw-text-sm tw-text-gray-500 tw-font-medium"
                        >
                          <svg
                            class="tw-w-4 tw-h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style="margin-top: 3px; margin-right: 2px"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                            ></path>
                          </svg>
                          {{ sheet.message }}
                        </div>
                      </div>
                      <div
                        v-if="
                          !sheet.success &&
                          sheet.include &&
                          storeState.autoImport.success
                        "
                        class="md:tw-col-span-12 tw-text-gray-900 tw-cursor-default tw-mx-2"
                        :class="{ 'tw-text-red-600': !sheet.success }"
                      >
                        {{ sheet.message }}
                        <div>
                          Try specifying the range your data is in (e.g. "A:G")
                          above.
                        </div>
                      </div>
                    </div>
                    <div class="tw-mt-8" v-if="storeState.autoImport.schedule">
                      <div class="tw-text-gray-900 tw-font-bold">
                        Repeat (Schedule)
                      </div>
                      <div class="tw-mt-2">
                        <div class="tw-mt-3 tw-cursor-pointer tw-inline-block">
                          <v-select
                            ref="repeatPeriod"
                            :items="intervals"
                            v-model="storeState.autoImport.repeat.period"
                            placeholder="Every"
                            single-line
                            dense
                            class="denser"
                          >
                            <template v-slot:selection="data">
                              <div
                                :data-type="data.item.value"
                                class="tw-cursor-pointer"
                              >
                                <!-- <v-icon small class="">{{data.item.icon}}</v-icon> -->
                                <span class="tw-pl-0">{{
                                  data.item.text
                                }}</span>
                              </div>
                            </template>
                            <template v-slot:item="data">
                              <div
                                :data-type="data.item.value"
                                class="tw-cursor-pointer"
                              >
                                <v-icon small>{{ data.item.icon }}</v-icon>
                                <span class="tw-pl-0">{{
                                  data.item.text
                                }}</span>
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <div class="tw-cursor-pointer tw-inline-block">
                          <v-text-field
                            ref="minutesPast"
                            v-if="
                              storeState.autoImport.repeat.period === 'hourly'
                            "
                            placeholder="Minutes past"
                            v-model="storeState.autoImport.repeat.minutesPast"
                            single-line
                            dense
                            class="denser"
                          ></v-text-field>
                          <div
                            v-if="
                              ['daily', 'weekly', 'monthly'].includes(
                                storeState.autoImport.repeat.period
                              )
                            "
                            class="tw-flex tw-inline-block"
                          >
                            <v-select
                              placeholder="Time"
                              :items="runTimes"
                              v-model="storeState.autoImport.repeat.runTime"
                              single-line
                              dense
                              class="denser"
                            ></v-select>
                            <a
                              id="utcTime"
                              href="https://www.google.com/search?q=utc+time+converter"
                              target="_blank"
                              >UTC</a
                            >
                          </div>
                        </div>
                        <div>
                          <div
                            v-if="
                              storeState.autoImport.repeat.period === 'weekly'
                            "
                            class="tw-cursor-pointer tw-inline-block"
                          >
                            <v-select
                              placeholder="Day"
                              :items="daysOfWeek"
                              v-model="storeState.autoImport.repeat.dayOfWeek"
                              single-line
                              dense
                              class="denser"
                            ></v-select>
                          </div>
                          <div
                            v-if="
                              storeState.autoImport.repeat.period === 'monthly'
                            "
                            class="tw-cursor-pointer tw-inline-block"
                          >
                            <v-text-field
                              ref="dayOfMonth"
                              placeholder="Day of month (e.g. 1)"
                              v-model="storeState.autoImport.repeat.dayOfMonth"
                              :rules="[fieldRules.isNum, fieldRules.required]"
                              hint="Use -1 for the last day of the month"
                              single-line
                              dense
                              class="denser"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tw-mt-8 tw-pb-12">
                      <span
                        v-if="
                          !storeState.autoImport.schedule &&
                          storeState.autoImport.success
                        "
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="storeState.autoImport.schedule = true"
                      >
                        Schedule Import
                      </span>
                      <span
                        v-if="
                          storeState.autoImport.schedule &&
                          storeState.autoImport.success
                        "
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="saveImportSchedule"
                      >
                        Save Schedule
                      </span>
                      <span
                        v-if="!storeState.autoImport.running"
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="doneImporting"
                      >
                        Import
                        {{
                          storeState.autoImport.spreadSheetMetadata.sheets.filter(
                            (s) => s.include
                          ).length
                        }}
                        sheets
                      </span>
                      <span v-else class="tw-float-right tw-mr-8">
                        <div class="tw-pt-0 tw-inline-block">
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="3"
                            color="primary"
                            class="tw-inline-block"
                          >
                          </v-progress-circular>
                        </div>
                      </span>
                      <span
                        class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer hover:tw-text-gray-600"
                        @click="cancelImport"
                      >
                        Cancel
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END CREATE TABLE FROM SHEETS -->
            <!-- TRASH / DELETED -->
            <div
              v-else-if="storeState.cmdkParentCmd === 'trash'"
              class="tw-bg-white tw-h-50vh tw-mx-4 tw-my-4 tw-overflow-scroll"
            >
              <div class="tw-text-3xl tw-font-bold">Trash</div>
              <div class="tw-pt-4" v-if="storeState.gettingTrash">
                <div class="tw-pt-0 tw-inline-block">
                  <v-progress-circular
                    indeterminate
                    :size="20"
                    :width="3"
                    color="primary"
                    class="tw-inline-block"
                  >
                  </v-progress-circular>
                </div>
                <div class="tw-align-text-top tw-inline-block tw-pl-4">
                  Getting trash
                </div>
              </div>
              <div v-else>
                <div
                  v-for="(block, key, index) in storeState.trash"
                  :key="index"
                >
                  <div
                    class="md:tw-grid md:tw-grid-cols-12 md:tw-gap-2 tw-mt-6"
                  >
                    <div class="md:tw-col-span-1 tw-py-3">
                      <img
                        class="tw-rounded-full tw-h-4 tw--mb-1"
                        :src="getUserPic(block.email)"
                      />
                    </div>
                    <div class="md:tw-col-span-8 tw-py-2">
                      {{ block.title || "Untitled" }}
                    </div>
                    <div class="md:tw-col-span-3 tw-text-right">
                      <div
                        @click="restoreFromTrash(key)"
                        class="tw-py-2 tw-cursor-pointer hover:tw-text-gray-700 tw-font-bold"
                      >
                        Restore
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ROLES PERMISSIONS -->
            <div
              v-else-if="
                storeState.cmdkParentCmd === 'updateUserRolesPermissions2'
              "
              class="tw-bg-white tw-h-50vh tw-mx-4 tw-my-4 tw-overflow-scroll"
            >
              <div class="tw-text-3xl tw-font-bold">Team Roles</div>
              <div
                v-for="(member, index) in storeState.settings.team.members"
                :key="index"
              >
                <div class="md:tw-grid md:tw-grid-cols-12 md:tw-gap-2 tw-mt-6">
                  <div class="md:tw-col-span-1 tw-py-3">
                    <img
                      class="tw-rounded-full tw-h-4 tw--mb-1"
                      :src="getUserPic(member.email)"
                    />
                  </div>
                  <div class="md:tw-col-span-5 tw-py-2">
                    {{ member.email }}
                  </div>
                  <div class="md:tw-col-span-6">
                    <div class="tw-relative">
                      <span
                        class="tw-inline-block tw-w-40 tw-rounded-md tw-shadow-sm tw-space-y-1"
                      >
                        <button
                          @click="setUpdatingRole(index, member)"
                          type="button"
                          aria-haspopup="listbox"
                          aria-expanded="true"
                          aria-labelledby="listbox-label"
                          class="tw-cursor-pointer tw-font-medium tw-text-gray-600 tw-relative tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-gray-300 tw-bg-white tw-pl-3 tw-pr-10 tw-py-2 tw-text-left focus:tw-outline-none focus:tw-shadow-outline-blue focus:tw-border-blue-300 tw-transition tw-ease-in-out tw-duration-150 sm:tw-text-sm sm:tw-leading-5"
                        >
                          <span class="tw-block tw-truncate">
                            {{ member.role }}
                          </span>
                          <span
                            class="tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-2 tw-pointer-events-none"
                          >
                            <svg
                              class="tw-h-5 tw-w-5 tw-text-gray-400"
                              viewBox="0 0 20 20"
                              fill="none"
                              stroke="currentColor"
                            >
                              <path
                                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </span>
                        </button>
                      </span>
                      <div
                        class="tw-absolute tw-mt-1 tw-w-40 tw-rounded-md tw-bg-white tw-shadow-lg tw-z-10"
                      >
                        <ul
                          v-if="member.updatingRole"
                          tabindex="-1"
                          role="listbox"
                          aria-labelledby="listbox-label"
                          aria-activedescendant="listbox-item-3"
                          class="tw-max-h-60 tw-rounded-md tw-py-1 tw-text-base tw-leading-6 tw-shadow-xs tw-overflow-auto focus:tw-outline-none sm:tw-text-sm sm:tw-leading-5"
                        >
                          <li
                            v-for="(roleType, index2) in roleTypes"
                            :key="index2"
                            @click="setRoleType(index, member, roleType)"
                            role="option"
                            class="tw-cursor-pointer tw-text-gray-900 hover:tw-bg-gray-200 tw-cursor-default tw-select-none tw-relative tw-py-2 tw-pl-3 tw-pr-9"
                          >
                            <span class="tw-font-normal tw-block tw-truncate">
                              {{ roleType.value }}
                            </span>
                            <span
                              v-if="member.role === roleType.value"
                              class="tw-text-gray-600 tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4"
                            >
                              <svg
                                class="tw-h-5 tw-w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clip-rule="evenodd"
                                ></path>
                              </svg>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="member.role === 'restricted'" class="tw-ml-1">
                      <v-combobox
                        ref="permissions"
                        v-model="member.membership_details.permissions"
                        :items="storeState.permissions"
                        v-on:change="permissionsChange(member)"
                        :menu-props="{
                          closeOnClick: true,
                          closeOnContentClick: true,
                        }"
                        placeholder="Permissions"
                        autofocus
                        item-text="value"
                        item-value="value"
                        chips
                        label=""
                        multiple
                        single-line
                        auto-select-first
                        hide-selected
                        append-icon=""
                        dense
                        class="denser"
                      >
                        <template
                          v-slot:selection="{ attrs, item, select, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            :input-value="selected.text"
                            close
                            dense
                            close-icon="mdi-close"
                            label
                            @click:close="removePermission(item, member)"
                          >
                            {{ item.value }}
                          </v-chip>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                No such permission,
                                <a
                                  target="_blank"
                                  href="https://www.notion.so/Team-Roles-daf46dca299547fd8b62df3f5d6df943"
                                >
                                  click here for help.
                                </a>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-combobox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- {{storeState.updateUser}} -->
            </div>
            <!-- PIVOT TABLE -->
            <div
              v-else-if="storeState.cmdkParentCmd === 'pivotTable'"
              class="tw-my-4 tw-mx-4"
            >
              <div class="tw-mt-1 tw-flex tw-border tw-rounded-md tw-shadow-sm">
                <span
                  class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                >
                  Index
                </span>
                <div class="tw-inline-flex tw-w-full tw-pl-4 tw-mt-1 tw-mb-1">
                  <v-combobox
                    ref="pivotIndex"
                    v-model="storeState.block.pivot.index"
                    :items="storeState.block.pivot.origHeaders"
                    :menu-props="{
                      closeOnClick: true,
                      closeOnContentClick: true,
                    }"
                    autofocus
                    chips
                    label=""
                    multiple
                    single-line
                    auto-select-first
                    hide-selected
                    :search-input.sync="pivotTable.indexInput"
                    append-icon=""
                    dense
                    class="denser"
                  >
                    <template
                      v-slot:selection="{ attrs, item, select, selected }"
                    >
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected.text"
                        close
                        dense
                        close-icon="mdi-close"
                        label
                        @click:close="removeFromPivot(item, 'index')"
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No column for "<strong>{{
                              pivotTable.indexInput
                            }}</strong
                            >" <a>rerun query?</a>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </div>
              </div>
              <div class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm">
                <span
                  class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                >
                  Column
                </span>
                <div class="tw-inline-flex tw-w-full tw-pl-4 tw-mt-2 tw-pt-1">
                  <v-autocomplete
                    ref="pivotColumns"
                    style="font-size: 14px"
                    v-model="storeState.block.pivot.columns"
                    :items="storeState.block.pivot.origHeaders"
                    :menu-props="{
                      closeOnClick: true,
                      closeOnContentClick: true,
                    }"
                    return-object
                    label=""
                    single-line
                    auto-select-first
                    hide-selected
                    :search-input.sync="pivotTable.columnsInput"
                    append-icon=""
                    dense
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No column for "<strong>{{
                              pivotTable.columnsInput
                            }}</strong
                            >"
                            <a>rerun query?</a>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
              <div class="tw-mt-4 tw-flex tw-border tw-rounded-md tw-shadow-sm">
                <span
                  class="tw-w-32 tw-inline-flex tw-items-center tw-px-3 tw-rounded-l-md tw-bg-gray-100 tw-text-gray-500 sm:tw-text-sm"
                >
                  Value
                </span>
                <div class="tw-inline-flex tw-w-full tw-pl-4 tw-mt-2 tw-pt-1">
                  <v-autocomplete
                    ref="pivotValues"
                    style="font-size: 14px"
                    v-model="storeState.block.pivot.values"
                    :items="storeState.block.pivot.origHeaders"
                    :menu-props="{
                      closeOnClick: true,
                      closeOnContentClick: true,
                    }"
                    label=""
                    return-object
                    single-line
                    auto-select-first
                    hide-selected
                    :search-input.sync="pivotTable.valuesInput"
                    append-icon=""
                    dense
                    class="denser"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            No column for "<strong>{{
                              pivotTable.valuesInput
                            }}</strong
                            >"
                            <a>rerun query?</a>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
              <div class="tw-pt-8">
                <v-tooltip left dark color="#333">
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer"
                      @click="runCode"
                    >
                      Done
                    </span>
                  </template>
                  <span class="tooltip-text">Done</span>
                  <span class="key">
                    <span
                      v-if="storeState.isMac"
                      class="key-inner key-inner-icon"
                    >
                      <v-icon color="#fff !important" size="12"
                        >mdi-apple-keyboard-command</v-icon
                      >
                    </span>
                    <span v-else class="key-inner"> Ctrl </span>
                  </span>
                  <span class="key">
                    <span class="key-inner">enter</span>
                  </span>
                </v-tooltip>
              </div>
            </div>
            <!-- END PIVOT TABLE -->
            <div
              v-else-if="storeState.cmdkParentCmd === 'getApiKey'"
              class="tw-my-4 tw-mx-4"
            >
              <div v-if="!storeState.apiKey" class="tw-flex tw-justify-center">
                <div class="tw-pt-16">
                  <v-progress-circular
                    indeterminate
                    :size="40"
                    :width="6"
                    color="primary"
                  >
                  </v-progress-circular>
                </div>
              </div>
              <div v-else class="tw-px-4">
                <div class="tw-py-4 tw-text-lg tw-font-bold">
                  Your key is below, do not share this key with anyone.
                </div>
                <div
                  class="tw-bg-gray-300 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-4 tw-mb-4 tw-rounded-sm tw-shadow tw-shadow-lg tw-text-center"
                  @click="copyText(`${storeState.apiKey}`)"
                >
                  {{ storeState.apiKey }}
                </div>
              </div>
            </div>
            <div
              v-else-if="storeState.cmdkParentCmd === 'shareBlock2'"
              class="tw-my-4 tw-mx-4"
            >
              <div
                v-if="storeState.shareUrl.includes('/run/')"
                class="tw-py-4 tw-text-lg tw-font-bold"
              >
                Click to copy and share with anyone on your team
              </div>
              <div v-else class="tw-py-4 tw-text-lg tw-font-bold">
                Click to copy and share with anyone or embed
              </div>
              <div
                class="tw-bg-gray-300 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-4 tw-mb-4 tw-rounded-sm tw-shadow tw-shadow-lg tw-text-center"
                @click="copyText(`${storeState.shareUrl}`)"
              >
                {{ storeState.shareUrl }}
              </div>
            </div>
            <div
              v-else-if="storeState.cmdkParentCmd === 'sendInvite2'"
              class="tw-my-4 tw-mx-4"
            >
              <div v-if="sendingInvites" class="tw-flex tw-justify-center">
                <div class="tw-pt-16">
                  <v-progress-circular
                    indeterminate
                    :size="40"
                    :width="6"
                    color="primary"
                  >
                  </v-progress-circular>
                </div>
              </div>
              <div v-else class="tw-px-4">
                <div class="tw-py-4 tw-text-lg tw-font-bold">
                  Invite sent via email, you can also share this link to invite
                  teammates
                </div>
                <div
                  class="tw-bg-gray-300 tw-cursor-pointer tw-font-bold tw-px-4 tw-py-4 tw-rounded-sm tw-shadow tw-shadow-lg tw-text-center"
                  @click="
                    copyText(
                      `https://www.seekwell.io/create?invite=${storeState.inviteId}`
                    )
                  "
                >
                  https://www.seekwell.io/create?invite={{
                    storeState.inviteId
                  }}
                </div>
              </div>
            </div>
            <div
              v-else-if="storeState.cmdkParentCmd === 'sendInvite'"
              class="tw-py-4"
            >
              <div class="tw-font-bold tw-text-2xl tw-mx-8">
                Invite team member
              </div>
              <div
                v-for="(email, index) in storeState.invites"
                v-bind:key="index"
                class="tw-mx-8 tw-my-8"
              >
                <div class="tw-mt-1 tw-relative tw-rounded-md tw-shadow-sm">
                  <div
                    class="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none"
                  >
                    <svg
                      class="tw-h-5 tw-w-5 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884zM18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <input
                    v-model="storeState.invites[index]"
                    class="tw-shadow tw-pl-10 tw-form-input tw-flex-1 tw-block tw-w-full tw-px-3 tw-py-2 tw-rounded-none tw-rounded-r-md sm:tw-text-sm sm:tw-leading-5"
                    placeholder="you@example.com"
                  />
                </div>
              </div>
              <span
                class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer"
                @click="sendInvite2"
              >
                Done
              </span>
              <span
                class="tw-float-right tw-pr-6 tw-font-bold tw-cursor-pointer"
                @click="storeState.invites.push('')"
              >
                Add another email
              </span>
            </div>
            <div
              v-else
              v-for="(item, index) in cmdkFiltered.slice(0, 10)"
              v-bind:key="item.cmd"
              v-bind:id="item.cmd"
              :ref="'cmdkItem_' + index"
              @mouseover="hoverCmdK(item.cmd)"
              @mouseleave="hoverCmdK(item.cmd)"
              @click="cmdkClick"
              :class="{
                'cmdk-row-container': true,
                'cmdk-active': index === storeState.searchIndex,
                'cmdk-hover': storeState.searchIndex < 0,
              }"
            >
              <v-row v-if="item.parent === 'useSnippet'" class="cmdk-row">
                <v-col cols="12" sm="12" md="12" class="text-left">
                  {{ item.description }}
                  <span class="tw-text-gray-500">
                    {{ item.detail.slice(0, 100) }}
                  </span>
                </v-col>
              </v-row>
              <v-row v-else class="cmdk-row">
                <v-col cols="12" sm="1" md="1" style="padding-top: 6px">
                  <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                </v-col>
                <v-col cols="12" sm="8" md="8" class="text-left">
                  {{ item.description }}
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                  class="text-right"
                  v-if="item.keys"
                >
                  <span v-for="key in item.keys" v-bind:key="key.key">
                    <span>
                      <span class="key">
                        <span
                          v-if="key.type === 'icon'"
                          class="key-inner-cmdk key-inner-icon-cmdk"
                        >
                          <v-icon color="#fff" size="12">{{ key.icon }}</v-icon>
                        </span>
                        <span v-else class="key-inner-cmdk">{{ key.key }}</span>
                      </span>
                    </span>
                  </span>
                </v-col>
              </v-row>
            </div>
            <div class="tw-px-8 tw-pb-8" v-if="!storeState.gotBlocks">
              Your snippets are still loading...
            </div>
            <div
              class="tw-px-8 tw-pb-8"
              v-if="storeState.gotBlocks && noSnippets"
            >
              Learn more about snippets
              <a
                class="tw-text-blue-500"
                href="https://www.notion.so/Snippets-88bb32aaf06743149b892ae93d8a0e24"
                target="_blank"
              >
                here.
              </a>
            </div>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <div
      v-if="
        storeState.settings.user.me.trial_expired > 0 &&
        storeState.settings.user.me.plan_type === 'trial'
      "
      @click="upgrade"
      class="trial-expired tw-absolute tw-h-12 tw-pt-3 tw-bottom-0 tw-w-1/3 tw-z-50 tw-mb-8"
    >
      Your trial is expired, please
      <span style="text-decoration: underline"> select a plan.</span>
    </div>
    <div
      v-if="
        !storeState.showHelp &&
        !storeState.hideHelp &&
        ![3, 4].includes(storeState.viewNumber)
      "
      @click="showHelpNow"
      class="get-help clickable"
    >
      <v-icon large>mdi-help-circle</v-icon>
    </div>
    <div
      v-if="storeState.showHelp"
      @click="storeState.showHelp = false"
      class="get-help clickable"
    >
      <v-icon large>mdi-close</v-icon>
    </div>
    <div
      v-if="storeState.runningNowIds.length > 0"
      class="tw-fixed tw-bottom-0 tw-mb-6 tw-ml-6 tw-z-10"
    >
      <div
        :class="{
          'pulse-spinner': true,
          'tw-bg-black': true,
          'tw-text-white': true,
          'tw-shadow-xl': true,
          'hover:tw-shadow': true,
          'tw-rounded-full': true,
          'tw-h-10': true,
          'tw-w-10': true,
          'tw-flex': true,
          'tw-items-center': true,
          'tw-justify-center': true,
        }"
      >
        <div class="tw-font-bold">
          {{ storeState.runningNowIds.length }}
        </div>
      </div>
    </div>
    <div v-if="storeState.showHelp" class="help help-container">
      <div class="help help-row" @click="helpLink('getting-started')">
        🚀 Getting started with SeekWell
      </div>
      <div class="help help-row" @click="helpLink('knowledgebase')">
        📚 Guide / Docs
      </div>
      <v-tooltip left dark color="#333">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="help help-row" @click="helpLink('account')">
            😃 Account
          </div>
        </template>
        <span class="tooltip-text">
          Signed in as {{ storeState.settings.user.me.email }}
        </span>
      </v-tooltip>
      <div class="help help-row" @click="helpLink('email')">📧 Email us</div>
      <div class="help help-row" @click="helpLink('chat')">💬 Chat</div>
      <div class="help help-row" @click="helpLink('demo')">
        📅 Demo / Onboarding
      </div>
      <div class="help help-row" @click="logout">🚪 Logout</div>
    </div>
    <router-view></router-view>
    <v-snackbar v-model="storeState.snackbar" :timeout="storeState.snacktime">
      <span v-html="storeState.message"></span>
      <v-btn text @click="storeState.snackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { store } from "./store.js";
import fuzz from "fuzzball";
import _ from "lodash";

// import '@/assets/styles/tailwind.css'

// https://stackoverflow.com/questions/40486163/use-vm-on-to-listen-to-event-emitted-from-child-in-vue-js-2-0
window.bus = new Vue({});

// Vue.directive('click-outside', {
//   bind: function (el, binding, vnode) {
//     el.clickOutsideEvent = function (event) {
//       // here I check that click was outside the el and his childrens
//       if (!(el == event.target || el.contains(event.target))) {
//         // and if it did, call method provided in attribute value
//         vnode.context[binding.expression](event);
//       }
//     };
//     document.body.addEventListener('click', el.clickOutsideEvent)
//   },
//   unbind: function (el) {
//     document.body.removeEventListener('click', el.clickOutsideEvent)
//   },
// });

let handleOutsideClick;
Vue.directive("closable", {
  bind(el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },

  unbind() {
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  },
});

let handleOutsideClick2;
Vue.directive("closabletwo", {
  bind(el, binding, vnode) {
    handleOutsideClick2 = (e) => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;
      exclude.forEach((refName) => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          if (excludedEl) {
            clickedOnExcludedEl = excludedEl.contains(e.target);
          }
        }
      });
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };
    document.addEventListener("click", handleOutsideClick2);
    document.addEventListener("touchstart", handleOutsideClick2);
  },

  unbind() {
    document.removeEventListener("click", handleOutsideClick2);
    document.removeEventListener("touchstart", handleOutsideClick2);
  },
});

export default {
  created() {
    this.getUserData();
    this.startSoup();
  },
  mounted() {
    window.bus.$on("doneTempRun", (details) => {
      if (details.opts && details.opts.autoImport) {
        this.$forceUpdate();
      }
    });
    this.$mousetrap.bind("/", this.slash);
    this.$mousetrap.bind("$", this.openStripe);
    this.$mousetrap.bind("r", this.handleR);
    this.$mousetrap.bind("o", this.openLink);
    this.$mousetrap.bind("q", this.goToQueues);
    // this.$mousetrap.bind('v', this.toggleView);
    this.$mousetrap.bind("t", this.addTag);
    this.$mousetrap.bind("m", this.addComment);
    this.$mousetrap.bind("c", this.newBlock);
    this.$mousetrap.bind("shift+c", this.newWindow);
    this.$mousetrap.bind("e", this.markDone);
    this.$mousetrap.bind(["ctrl+[", "alt+["], this.blockHistoryNavBack);
    this.$mousetrap.bind(["ctrl+]", "alt+]"], this.blockHistoryNavForward);
    this.$mousetrap.bind("esc", this.handleEsc);
    this.$mousetrap.bind(["command+k", "ctrl+k"], this.openCmdK);
    this.$mousetrap.bind(["command+;", "ctrl+;"], this.useSnippet);
    this.$mousetrap.bind(["s"], this.handleS);
    this.$mousetrap.bind(["up", "down"], this.upDown);
    this.$mousetrap.bind(["enter"], this.handleEnter);
    this.$mousetrap.bind(["command+enter", "ctrl+enter"], this.cmdEnter);
    this.$mousetrap.bind(["tab"], this.handleTab);
    //view number
    //1 = current main view
    this.$mousetrap.bind(["ctrl+1", "alt+1"], this.changeViewNumber); //main / starting
    this.$mousetrap.bind(["ctrl+2", "alt+2"], this.changeViewNumber); //zen code, e.g. no table
    this.$mousetrap.bind(["ctrl+3", "alt+3"], this.changeViewNumber); //big table
    this.$mousetrap.bind(["ctrl+4", "alt+4"], this.changeViewNumber); //big chart
    this.$mousetrap.bind(["ctrl+5", "alt+5"], this.changeViewNumber); //schema explorer
    this.$mousetrap.prototype.stopCallback = function (e, element, combo) {
      console.log("eval key", combo);

      // if the element has the class "mousetrap" then no need to stop
      if (
        (" " + element.className + " ").indexOf(" mousetrap ") > -1 &&
        ["command+enter", "ctrl+enter", "right", "left", "tab"].indexOf(combo) >
          -1
      ) {
        return false;
      }

      if (
        [
          "command+enter",
          "ctrl+enter",
          "command+k",
          "ctrl+k",
          "command+;",
          "ctrl+;",
        ].indexOf(combo) > -1
      ) {
        return false;
      }

      if (["command+[", "command+]", "ctrl+[", "ctrl+]"].indexOf(combo) > -1) {
        //scrolling thru history
        return false;
      }

      if (
        [
          "ctrl+1",
          "ctrl+2",
          "ctrl+3",
          "ctrl+4",
          "alt+1",
          "alt+2",
          "alt+3",
          "alt+4",
        ].indexOf(combo) > -1
      ) {
        return false;
      }

      if (["esc"].indexOf(combo) > -1) {
        return false;
      }

      if (
        ["down", "up", "enter", "command+right", "ctrl+right"].indexOf(combo) >
        -1
      ) {
        return false;
      }

      if (
        e.target.className.includes("ProseMirror") &&
        !store.state.showSuggestions
      )
        return true;

      // stop for input, select, and textarea
      return (
        element.tagName == "INPUT" ||
        element.tagName == "SELECT" ||
        element.tagName == "TEXTAREA" ||
        (element.contentEditable && element.contentEditable == "true")
      );
    };
    this.$el.addEventListener("click", this.onClick);
    // document.addEventListener('keydown', function(e) {
    //   console.log('cmd enter', e)
    //   if(!(e.keyCode == 13 && e.metaKey)) return;

    //   var target = e.target;
    //   if(target.form) {
    //     target.form.submit();
    //   }
    // });
    window.bus.$on("loginAsDone", (details) => {
      console.log("loginAsDone.....", details);
      this.getUserData();
      this.$router.push({ path: "/" });
    });
    window.bus.$on("invitesSent", (details) => {
      this.sendingInvites = false;
    });
  },
  data() {
    return {
      intervals: [
        { value: "hourly", text: "Hourly" },
        { value: "daily", text: "Daily" },
        { value: "weekly", text: "Weekly" },
        { value: "monthly", text: "Monthly" },
        { value: "fivemin", text: "5 minutes" },
      ],
      daysOfWeek: [
        { value: "monday", text: "Monday" },
        { value: "tuesday", text: "Tuesday" },
        { value: "wednesday", text: "Wednesday" },
        { value: "thursday", text: "Thursday" },
        { value: "friday", text: "Friday" },
        { value: "saturday", text: "Saturday" },
        { value: "sunday", text: "Sunday" },
      ],
      loadingSheets: false,
      searchSpreadsheet: null,
      setting: {
        updateUser: {
          role: false,
        },
      },
      roleTypes: [
        {
          label: "Admin",
          value: "admin",
        },
        {
          label: "User",
          value: "user",
        },
        {
          label: "Restricted",
          value: "restricted",
        },
      ],
      pivotTable: {
        indexInput: "",
        columnsInput: "",
        valuesInput: "",
      },
      temploading: true,
      storeState: store.state,
      sendingInvites: false,
      // sendingInvites: store.state.sendingInvites,
      cmdkPlaceholder: "",
      editableDetails: store.state.editableDetails,
      snackbar: false,
      cmdkData: {},
      onSnip: false,
      hover: false,
      noSnippets: false,
      noForms: false,
      cmdks: [
        {
          cmd: "settings",
          description: "Settings",
          icon: "mdi-settings",
          search: "settings,team,user,admin",
          children: this.settingsChildren,
          f: this.openSettings,
        },
        {
          cmd: "getHelp",
          description: "Help",
          icon: "mdi-help-circle",
          search: "help,assist,question",
          f: this.showHelpCmdk,
        },
        {
          cmd: "refreshMeta",
          description: "Refresh data",
          icon: "mdi-refresh",
          shortcut: "cmd+shift+r",
          search: "refresh,data,sql",
          f: this.refreshMeta,
        },
        {
          cmd: "logout",
          description: "Logout",
          icon: "mdi-exit-to-app",
          shortcut: "cmd+e",
          html: "<span>Expand</span>",
          next: "expand2",
          search: "logout, sign out",
          f: this.logout,
        },
        {
          cmd: "addIntegration",
          description: "New Integration (Source + Destination)",
          icon: "mdi-database",
          search: "source,destination,new,add,integration",
          f: this.addIntegration,
        },
        {
          cmd: "changeSource",
          description: "Change Source",
          icon: "mdi-database",
          search: "source,change,switch",
          f: this.changeSource,
        },
        {
          cmd: "usageReport",
          description: "Usage Report",
          icon: "mdi-receipt",
          search: "report,usage,runs,run",
          f: this.usageReport,
        },
        // {
        //   cmd: 'search',
        //   focus: 'main',
        //   description: 'Search',
        //   icon: 'mdi-launch',
        //   shortcut: 'cmd+e',
        //   html: '<span>Expand</span>',
        //   next: 'expand2',
        //   search: 'search,slash',
        //   f: this.slash,
        //   keys: [
        //     {
        //       key: '/'
        //     },
        //   ]
        // },
        {
          cmd: "editSources",
          description: "Edit sources",
          icon: "mdi-database",
          search: "switch,change,database,edit,source,sources",
          f: this.switchSource,
        },
        {
          cmd: "goToRun",
          description: "New SQL block",
          icon: "mdi-play-circle-outline",
          html: "<span>Expand</span>",
          next: "expand2",
          search: "create,new,run,sql",
          f: this.goToRun,
          keys: [
            {
              key: "C",
            },
          ],
        },

        {
          cmd: "newWindow",
          description: "New tab / window",
          icon: "mdi-open-in-new",
          html: "<span>Expand</span>",
          next: "expand2",
          search: "create,new,run,sql",
          f: this.newWindow,
          keys: [
            {
              key: "Shift",
            },
            {
              key: "C",
            },
          ],
        },
        {
          cmd: "useSnippet",
          description: "Use snippet",
          icon: "mdi-content-cut",
          search: "use,add,snippet,snippets",
          children: this.useSnippetChildren,
          f: this.useSnippet,
          keys: [
            {
              key:
                navigator.platform.toUpperCase().indexOf("MAC") >= 0
                  ? "⌘"
                  : "Ctrl",
            },
            {
              key: "+",
            },
            {
              key: ";",
            },
          ],
        },
        {
          cmd: "createSnippet",
          description: "New snippet",
          icon: "mdi-content-cut",
          search: "new,create,snippet,snippets",
          f: this.createSnippet,
        },
        {
          cmd: "goToSnippets",
          description: "View snippets",
          icon: "mdi-eye",
          search: "view,go,snippets",
          f: this.goToSnippets,
        },
        {
          cmd: "goToBlocks",
          description: "Go to Blocks",
          icon: "mdi-home",
          search: "go,blocks,home",
          f: this.goToBlocks,
          keys: [
            {
              key: "esc",
            },
          ],
        },
        {
          cmd: "openForm",
          description: "Create Form from this block",
          icon: "mdi-file-document-edit-outline",
          focus: "run",
          search: "create,new,form",
          f: this.goToForm,
        },
        {
          cmd: "formActions",
          description: "Form actions",
          icon: "mdi-file-document-edit-outline",
          focus: "form",
          search: "form,actions",
          f: this.formActions,
          children: this.formChildren,
        },
        {
          cmd: "useForm",
          description: "List all Forms",
          icon: "mdi-file-document-edit-outline",
          search: "use,form",
          children: this.useFormChildren,
          f: this.useForm,
        },
        {
          cmd: "createTag",
          focus: "details",
          description: "New tag",
          icon: "mdi-tag",
          shortcut: "r",
          search: "create,tag",
          children: this.createTagChildren,
          f: this.createTag,
        },
        {
          cmd: "sets",
          description: "Explore Sets",
          icon: "mdi-magnify",
          html: "<span>Expand</span>",
          search: "explore,use,sets,set,go,to",
          f: this.exploreSets,
        },
        // {
        //   cmd: 'goToSets',
        //   description: 'View Sets',
        //   icon: 'mdi-poll-box',
        //   html: '<span>Expand</span>',
        //   search: 'view,sets,set,go,to,list',
        //   f: this.goToSets,
        // },
        {
          cmd: "createStory",
          description: "New Story",
          icon: "mdi-file-document-box-plus-outline",
          search: "go,to,create,new,add,story,",
          f: this.createStory,
        },
        {
          cmd: "goToStories",
          description: "View Stories",
          icon: "mdi-file-document-box-plus-outline",
          search: "go,to,story,",
          f: this.goToStories,
        },
        {
          cmd: "pivotTable",
          description: "Pivot table",
          icon: "mdi-subdirectory-arrow-left",
          // focus: 'run',
          search: "pivot,table",
          f: this.openPivotTable,
          children: function () {},
        },
        {
          cmd: "removePivotTable",
          description: "Remove pivot table",
          icon: "mdi-close",
          // focus: 'run',
          search: "pivot,remove",
          f: this.removePivotTable,
        },
        {
          cmd: "shareBlock",
          description: "Share",
          icon: "mdi-share",
          search: "share,public,embed",
          f: this.shareBlock,
          children: this.shareBlockChildren,
        },
        {
          cmd: "tables",
          description: "Go to Tables",
          icon: "mdi-table",
          html: "<span>Expand</span>",
          search: "use,go,tables,table,go,to",
          f: this.goToTables,
        },
        {
          cmd: "done",
          focus: "details",
          description: "Mark done / archive",
          icon: "mdi-package-down",
          shortcut: "E",
          html: "<span>Expand</span>",
          search: "mark,done,archive",
          f: this.markDone,
          keys: [
            {
              key: "E",
            },
          ],
        },
        {
          cmd: "flipToPython",
          description: "Use Python (3.7)",
          icon: "mdi-language-python",
          search: "python,use,flip",
          f: this.flipToPython,
        },
        {
          cmd: "listDocs",
          description: "List Dashboards",
          icon: "mdi-file-document-outline",
          search: "view,dashboard,dashboards,go,to,list",
          children: this.listDocsChildren,
          f: this.listDocs,
        },
        {
          cmd: "addToDoc",
          description: "Add to Dashboard",
          icon: "mdi-file-document-outline",
          search: "add,to,dashboard,dashboards",
          focus: "run",
          children: this.addToDocChildren,
          f: this.addToDoc,
        },
        {
          cmd: "createDoc",
          description: "Create Dashboard",
          icon: "mdi-file-document-box-plus-outline",
          html: "<span>Expand</span>",
          search: "create,new,add,dashboards,dashboard,go,to",
          f: this.createDoc,
        },
        {
          cmd: "sendInvite",
          description: "Invite team member",
          icon: "mdi-account-plus",
          search: "invite,add,new,user,team,people",
          children: this.sendInviteChildren,
          f: this.sendInvite,
        },
        {
          cmd: "sendInvite2",
          description: "Invite admin",
          icon: "mdi-account-plus",
          search: "invite,add,new,user,team,people",
          children: this.sendInviteChildren2,
          f: this.sendInvite2,
        },
        {
          cmd: "getApiKey",
          description: "Create API Key",
          icon: "mdi-key",
          search: "create,get,api,key,API",
          children: function () {},
          f: this.getApiKey,
        },
        {
          cmd: "createTablesFromSheet",
          description: "Import Sheet to SQL Database",
          icon: "mdi-table",
          search: "auto,import,sheet,sheets,table,database",
          children: function () {},
          f: this.createTablesFromSheet,
        },
        {
          cmd: "autoImportToSheets",
          description: "Import SQL Database to Sheets",
          icon: "mdi-table",
          search: "auto,import,sheet,sheets,table,database",
          children: function () {},
          f: this.autoImportToSheets,
        },
        {
          cmd: "twitter",
          description: "Enjoying SeekWell? Spread the word!",
          icon: "mdi-twitter",
          html: "<span>Expand</span>",
          search: "share,twitter",
          f: this.shareTwitter,
        },
        {
          cmd: "trash",
          description: "View trash",
          icon: "mdi-delete",
          search: "trash,delete,deleted",
          children: function () {},
          f: this.getTrash,
        },
      ],
    };
  },
  watch: {
    editableDetails: {
      handler: function (val, oldVal) {
        console.log(
          "watch editableDetails",
          "newval: ",
          val,
          "   oldVal:",
          oldVal
        );
        this.updateEditableDetails(this.storeState.details.email, "users", val);
      },
      deep: true,
    },
    "storeState.cmdkActive": {
      handler: function (val, oldVal) {
        if (!val) {
          this.storeState.cmdkForm = false;
          this.storeState.justClosedCmdk = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    doneAddingIntegration() {
      if (this.storeState.pendingIntegration.app_name == "Zendesk") {
        const path = store.getPath("/zendesk0");
        let d = {
          subdomain: this.storeState.pendingIntegration.domain,
          sessionId: this.storeState.sessionId,
        };
        var self = this;
        self.closeCmdk();
        axios
          .post(path, d)
          .then((res) => {
            console.log("got zendesk integartions: ", res.data);
            if (res.data.ok) {
              window.open(
                `https://${this.storeState.pendingIntegration.domain}.zendesk.com/oauth/authorizations/new?response_type=code&redirect_uri=https://seekwell.io/zendesk1&client_id=seekwell&scope=read%20write`,
                "_blank"
              );
              self.storeState.snackbar = true;
              self.storeState.message = `${this.storeState.pendingIntegration.app_name} added!`;
            }
            self.getSoupApps();
          })
          .catch((error) => {
            self.storeState.snackbar = true;
            self.storeState.message = error;
            console.error(error);
          });
      } else {
        const path = store.getPath("/soup_add_integration");
        let d = {
          sessionId: this.storeState.sessionId,
          integration: this.storeState.pendingIntegration,
        };
        var self = this;
        self.closeCmdk();
        axios
          .post(path, d)
          .then((res) => {
            console.log("got soup_add_integration: ", res.data);
            if (res.data.ok) {
              self.storeState.snackbar = true;
              self.storeState.message = `${this.storeState.pendingIntegration.app_name} added!`;
            }
            self.getSoupApps();
          })
          .catch((error) => {
            self.storeState.snackbar = true;
            self.storeState.message = error;
            console.error(error);
          });
      }
    },
    includeSheet(index, sheet) {
      sheet.include = !sheet.include;
      Vue.set(
        this.storeState.autoImport.spreadSheetMetadata.sheets,
        index,
        sheet
      );
    },
    includeSource(index, source) {
      source.include = !source.include;
      Vue.set(this.storeState.autoImport.tables, index, source);
      this.$forceUpdate();
    },
    getSheets() {
      const path = store.getPath("/soup_get_sheets");
      let d = {
        sessionId: this.storeState.sessionId,
        ss_id: this.storeState.autoImport.ss_id,
      };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log("got soup_get_sheets: ", res.data);
          if (!res.data.sheets) {
            this.storeState.snackbar = true;
            this.storeState.message = "Error getting Sheets metadata";
            return;
          }
          self.loadingSheets = false;
          self.storeState.autoImport.spreadSheetMetadata = res.data;
          for (
            let index = 0;
            index <
            self.storeState.autoImport.spreadSheetMetadata.sheets.length;
            index++
          ) {
            const element =
              self.storeState.autoImport.spreadSheetMetadata.sheets[index];
            element.include = true;
            element.table = element.properties.title
              .toLowerCase()
              .replaceAll(" ", "_")
              .replace(/[^\w\s]/gi, "_");
            if (this.storeState.autoImport.schema.length > 0)
              element.table = `${self.storeState.autoImport.schema}.${element.table}`;
          }
          self.$forceUpdate();
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    refreshSpreadSheets() {
      this.loadingSpreadsheets = true;
      this.getSoupSheets();
    },
    onImportDbChange(newVal) {
      console.log("onImportDbChange", newVal);
      this.storeState.autoImport.gettingTables = true;
      let newSource = this.storeState.allSources.find((s) => s.uuid === newVal);
      newSource.importDb = true;
      this.getDefaultMetaData(this, newSource);
      // this.storeState.autoImport.tables = JSON.parse(JSON.stringify(this.storeState.dbMeta.schemaTables))
      this.$forceUpdate();
    },
    onSpreadSheetChange(newVal) {
      console.log("onSpreadSheetChange", newVal);
      this.storeState.destinations.sheets = [];
      this.loadingSheets = true;
      this.getSheets();
    },
    onSpreadSheetChangeSource(newVal) {
      console.log("onSpreadSheetChange", newVal);
      this.storeState.block.source.sheets = [];
      this.getSheetsSource();
    },
    newSpreadsheet() {
      window.open("https://sheets.new/", "_blank");
    },
    setUpdatingRole(index, member) {
      member.updatingRole = !member.updatingRole;
      Vue.set(this.storeState.settings.team.members, index, member);
    },
    setRoleType(index, member, roleType) {
      member.updatingRole = false;
      member.role = roleType.value;
      Vue.set(this.storeState.settings.team.members, index, member);
      const path = store.getPath("/soup_update_user_settings");
      let d = {
        sessionId: this.storeState.sessionId,
        member: member,
        updateType: "role",
      };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log("res: ", res);
        })
        .catch((error) => {
          self.storeState.snackbar = true;
          self.storeState.message = error;
          console.error(error);
        });
    },
    permissionsChange(member) {
      console.log("updating permissions: ", member);
      const path = store.getPath("/soup_update_user_settings");
      let d = {
        sessionId: this.storeState.sessionId,
        member: member,
        updateType: "permissions",
      };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log("res: ", res);
        })
        .catch((error) => {
          self.storeState.snackbar = true;
          self.storeState.message = error;
          console.error(error);
        });
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(
        (u) => u.email === email
      );
      if (u) return u.pic;
      return "";
    },
    runCode() {
      store.runCode({});
      this.storeState.cmdkActive = false;
    },
    removePermission(item, member) {
      // storeState.settings.team.members member.membership_details.permissions
      console.log("removing ", item);
      let m = this.storeState.settings.team.members.find(
        (m) => m.email === member.email
      );
      m.membership_details.permissions =
        m.membership_details.permissions.filter((p) => p.value != item.value);
      this.permissionsChange(m);
    },
    removeFromPivot(item, param) {
      console.log("removing ", item);
      this.storeState.block.pivot[param] = this.storeState.block.pivot[
        param
      ].filter((p) => p.value != item.value);
    },
    refreshParamOptions(blockId, index) {
      let block = this.storeState.blocks[blockId];
      store.runTempBlock(block, {
        rowLimit: 10000,
        updateBlock: true,
        updateParamOptions: {
          blockId: this.storeState.cmdkForm.uuid,
          index: index,
        },
      });
    },
    upgrade() {
      let email = this.storeState.settings.user.me.email;
      var blockId = false;
      for (let [key, block] of Object.entries(this.storeState.blocks)) {
        if (block.email && block.email === email) {
          blockId = key;
          break;
        }
      }
      if (!blockId && Object.keys(this.storeState.blocks).length > 0) {
        blockId = Object.keys(this.storeState.blocks)[0];
      }
      var url = "https://seekwell.io/upgrade?ref=run";
      if (blockId) {
        url = `https://seekwell.io/upgrade?ref=run&blockId=${blockId}`;
      }
      var win = window.open(url, "_blank");
    },
    copyText(text) {
      this.$copyText(text);
      this.storeState.snackbar = true;
      this.storeState.message = "Copied!";
      this.storeState.cmdkActive = false;
    },
    helpLink(link) {
      let links = {
        account: "https://seekwell.io/profile?ref=webapp",
        upgrade: "https://seekwell.io/pricing?ref=webapp",
        knowledgebase:
          "https://www.notion.so/SeekWell-Knowledge-Base-7e6abd7243ca43ad863372a264c44452",
        chat: "https://seekwell.io/?ref=webapp&chat=1",
        email: "mailto:contact@seekwell.io",
        logout: "",
        "getting-started":
          "https://www.loom.com/share/2341af8796574626a671940302e8707d",
        demo: "https://www.getclockwise.com/c/tejas-sachdeva-thoughtspot-com/15-minute-meeting-with-tejas-sachdeva",
      };
      let curPath = this.$route.path;
      if (link === "chat") {
        // store.getHelp()
        this.storeState.showHelp = false;
        if (window.Intercom) window.Intercom("show");
        var lightweightApp = document.getElementsByClassName(
          "intercom-lightweight-app"
        );
        if (lightweightApp.length > 0) {
          lightweightApp[0].setAttribute("style", "display:block !important");
        }
        var intercomContainer = document.getElementById("intercom-container");
        if (intercomContainer)
          intercomContainer.setAttribute("style", "display:block !important");
        if (lightweightApp.length === 0 && !intercomContainer) {
          // delete window.Intercom
          var win = window.open("mailto:contact@seekwell.io", "_blank");
          // window.intercomSettings = {
          //   app_id: "nbdl7flf",
          //   email: this.storeState.settings.user.me.email
          // };
          // (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/nbdl7flf';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
        }
        if (window.Intercom) {
          window.Intercom("onHide", function () {
            var el = document.getElementById("intercom-container");
            if (el) el.setAttribute("style", "display:none !important");
          });
        }
      } else if (link === "logout") {
        this.logout();
      } else if (
        link === "knowledgebase" &&
        this.storeState.block.cellType === "snippets"
      ) {
        let url =
          "https://www.notion.so/Snippets-88bb32aaf06743149b892ae93d8a0e24";
        var win = window.open(url, "_blank");
      } else if (
        link === "knowledgebase" &&
        this.storeState.block.cellType === "story"
      ) {
        let url =
          "https://www.notion.so/Stories-d4dcb303d28b400492741b5741fc2f86";
        var win = window.open(url, "_blank");
      } else {
        var win = window.open(links[link], "_blank");
      }
    },
    showHelpNow() {
      this.storeState.showHelp = true;
    },
    showHelpCmdk() {
      this.storeState.showHelp = true;
      this.storeState.cmdkActive = false;
    },
    refreshMeta() {
      this.storeState.forceFullRefresh = true;
      this.getUserData(15000);
      this.getTaggedModels(this);
      let c = this.$children.find((c) => c.$refs.run);
      if (c) c.getExplore(this);
      this.storeState.cmdkActive = false;
    },
    runModelFromCmdk(m) {
      console.log("runModelFromCmdk: ", m);
      store.runDetails({ model: m.model.model });
      this.$router.push({ path: "/table" }).catch((err) => {});
      this.cmdkActive = false;
    },
    hoverCmdK() {
      this.storeState.searchIndex = -1;
    },
    openSettings() {
      let url = "https://seekwell.io/profile";
      var win = window.open(url, "_blank");
      win.focus();
    },
    openIntercom() {
      let url =
        "https://app.intercom.io/a/apps/nbdl7flf/users/segments/all-users?searchTerm=";
      url += this.storeState.details.email;
      var win = window.open(url, "_blank");
      win.focus();
    },
    openFullStory() {
      let se = this.storeState.details.email.replace("@", "%40");
      let url = `https://app.fullstory.com/ui/6NWKC/segments/everyone/people:search:((NOW%2FDAY-1000DAY:NOW%2FDAY%2B1DAY):((UserEmail:==:%22${se}%22)):():():():)/0`;
      var win = window.open(url, "_blank");
      win.focus();
    },
    compareValues(key, order = "asc") {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    addComment(e) {
      if (e && e.preventDefault) e.preventDefault();
      let uid = `comment_${(Math.random() * 1000000000000000000).toString()}`;
      let c = {
        text: "",
        title: "This title",
        user: "Mike",
        autofocus: true,
        uid: uid,
        disabled: false,
      };
      this.storeState.cmdkActive = false;
      this.storeState.editableDetails.comments.push(c);
    },
    addTag() {
      this.storeState.cmdkActive = false;
      this.storeState.tagActive = false;
      this.storeState.tagActive = true;
      this.changeFocus("main", this);
      var self = this;
      // self.$children[1].$refs.tagCombobox.focus()
      setTimeout(() => {
        // self.$children[0].$refs.tagCombobox.focus()
        if (self.$children[1].$refs.tagCombobox)
          self.$children[1].$refs.tagCombobox.focus();
      }, 0);
    },
    changeDefaultTime() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "changeDefaultTime";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
    },
    changeDefaultTimeChildren() {
      let cmdks = [];
      var self = this;
      let opts = [
        {
          label: `Today (${self.storeState.defaultTime.hour}:${self.storeState.defaultTime.minute})`,
          value: "today",
          search: "today",
          f: function () {
            return moment().set(self.storeState.defaultTime);
          },
        },
      ];
      return cmdks.filter((o) => o.search.includes(self.storeState.cmdkInput));
    },
    getApiKey() {
      this.storeState.cmdkParentCmd = "getApiKey";
      this.storeState.cmdkActive = true;
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      const path = store.getPath("/soup_get_api_key");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      self.storeState.apiKey = false;
      axios
        .post(path, d)
        .then((res) => {
          self.storeState.apiKey = res.data.apiKey;
          // self.$forceUpdate()
        })
        .catch((error) => {
          self.storeState.apiKey = "error";
          self.storeState.snackbar = true;
          self.storeState.message = error;
          console.error(error);
        });
    },
    getApiKeyChildren() {
      return [];
    },
    createSnippet() {
      let curPath = this.$route.path;
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      this.$router
        .push({ name: "Run", params: { id: blockId, snippet: true } })
        .catch((err) => console.error(err));
    },
    useSnippet() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "useSnippet";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      if (!curPath.startsWith("/run")) {
        let blockId = store.uuidv4();
        this.storeState.newBlocks.push(blockId);
        this.$router
          .push({ name: "Run", params: { id: blockId } })
          .catch((err) => console.error(err));
      }
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    useSnippet2(blockId) {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "useSnippet";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let block = this.storeState.blocks[blockId];
      if (!block) return;
      if (block.params) {
        this.storeState.cmdkForm = block;
      } else {
        this.newBlock();
        setTimeout(() => {
          window.bus.$emit("addSnippet", { block: block });
        }, 200);
      }
    },
    useForm() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "useForm";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    useForm2(blockId) {
      this.storeState.cmdkActive = false;
      this.storeState.cmdkParentCmd = false;
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      this.$router.push({ name: "Form", params: { id: blockId } });
    },
    useFormChildren() {
      let cmdks = [];
      var self = this;
      // iterate thru snippets in blocks
      for (let [key, block] of Object.entries(this.storeState.blocks)) {
        var cmdkSearch = block.title.replace(" ", ",");
        if (!cmdkSearch) {
          cmdkSearch = block.code;
        }
        let isForm = block.tags.filter((t) => t.text === "form");
        if (isForm.length > 0 && block.code.length > 0) {
          var title = block.title;
          if (title.length === 0) title = "Untitled";
          let cmdk = {
            cmd: `cmdkItem_${block.uuid}`,
            description: title,
            detail: block.code,
            label: title,
            value: block.uuid,
            search: cmdkSearch,
            children: function () {},
            parent: "useForm",
            icon: false,
            f: function () {
              self.useForm2(block.uuid);
            },
          };
          cmdks.push(cmdk);
        }
      }
      if (cmdks.length === 0) {
        this.noForms = true;
      }
      return cmdks;
    },
    createDoc(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      this.$router
        .push({ name: "Docs", params: { id: blockId } })
        .catch((err) => console.error(err));
      let self = this;
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault();
    },
    addToDoc() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "addToDoc";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    addToDoc2(blockId) {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "addToDoc2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let doc = this.storeState.blocks[blockId];
      let tileId = store.uuidv4();
      var height = 15;
      let defaultLayout = { x: 0, y: 0, w: 4, h: 10, i: "abcdefg" };
      if (doc.doc.layout.length === 0) {
        var tile = defaultLayout;
        tile.i = tileId;
      } else {
        let last = doc.doc.layout[doc.doc.layout.length - 1];
        var tile = {
          x: defaultLayout.x,
          y: last.y + 1,
          w: defaultLayout.w,
          h: defaultLayout.h,
          i: tileId,
        };
      }
      tile.block = { uuid: this.storeState.block.uuid };
      tile.type = "tables";
      tile.h = height;
      doc.doc.layout.push(tile);
    },
    addToDocChildren() {
      let cmdks = [];
      var self = this;
      // iterate thru snippets in blocks
      for (let [key, block] of Object.entries(this.storeState.blocks)) {
        var cmdkSearch = block.title.replace(" ", ",");
        if (block.cellType === "doc") {
          var title = block.title;
          if (title.length === 0) title = "Untitled";
          let cmdk = {
            cmd: `cmdkItem_${block.uuid}`,
            description: title,
            detail: block.code,
            label: title,
            value: block.uuid,
            search: cmdkSearch,
            // children: function() {},
            icon: false,
            f: function () {
              self.addToDoc2(block.uuid);
            },
          };
          cmdks.push(cmdk);
        }
      }
      if (cmdks.length === 0) {
        this.noForms = true;
      }
      return cmdks;
    },
    listDocs() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "listDocs";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    listDocsChildren() {
      let cmdks = [];
      var self = this;
      // iterate thru snippets in blocks
      for (let [key, block] of Object.entries(this.storeState.blocks)) {
        var cmdkSearch = block.title.replace(" ", ",");
        if (block.cellType === "doc") {
          var title = block.title;
          if (title.length === 0) title = "Untitled";
          let cmdk = {
            cmd: `cmdkItem_${block.uuid}`,
            description: title,
            detail: block.code,
            label: title,
            value: block.uuid,
            search: cmdkSearch,
            // children: function() {},
            icon: false,
            f: function () {
              self.openBlock(block.uuid);
            },
          };
          cmdks.push(cmdk);
        }
      }
      if (cmdks.length === 0) {
        this.noForms = true;
      }
      return cmdks;
    },
    shareWithTeam() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "shareBlock2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      var url = `https://app.seekwell.io/run/${this.storeState.block.uuid}`;
      if (this.storeState.block.params.length > 0) {
        url = `${url}?`;
        for (
          let index = 0;
          index < this.storeState.block.params.length;
          index++
        ) {
          const p = this.storeState.block.params[index];
          url = `${url}${p.name}=${p.value}&`;
        }
        url = url.slice(0, url.length - 1);
      }
      this.storeState.shareUrl = url;
    },
    shareWithTeam() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "shareBlock2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      var url = `https://app.seekwell.io/run/${this.storeState.block.uuid}`;
      if (this.storeState.block.params.length > 0) {
        url = `${url}?`;
        for (
          let index = 0;
          index < this.storeState.block.params.length;
          index++
        ) {
          const p = this.storeState.block.params[index];
          url = `${url}${p.name}=${p.value}&`;
        }
        url = url.slice(0, url.length - 1);
      }
      this.storeState.shareUrl = url;
    },
    shareBlock() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "shareBlock";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    shareTable() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "shareBlock2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      this.storeState.block.public = true;
      store.updateBlock({ gotBlock: this.storeState.gotBlock });
      var url = `https://app.seekwell.io/data/${this.storeState.block.uuid}`;
      if (this.storeState.block.params.length > 0) {
        url = `${url}?`;
        for (
          let index = 0;
          index < this.storeState.block.params.length;
          index++
        ) {
          const p = this.storeState.block.params[index];
          url = `${url}${p.name}=${p.value}&`;
        }
        url = url.slice(0, url.length - 1);
      }
      this.storeState.shareUrl = url;
    },
    shareChart() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "shareBlock2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      this.storeState.block.public = true;
      store.updateBlock({ gotBlock: this.storeState.gotBlock });
      var url = `https://app.seekwell.io/data/${this.storeState.block.uuid}?chart=1&`;
      if (this.storeState.block.params.length > 0) {
        for (
          let index = 0;
          index < this.storeState.block.params.length;
          index++
        ) {
          const p = this.storeState.block.params[index];
          url = `${url}${p.name}=${p.value}&`;
        }
        url = url.slice(0, url.length - 1);
      }
      this.storeState.shareUrl = url;
    },
    shareStory() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "shareBlock2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      this.storeState.block.public = true;
      store.updateBlock({ gotBlock: true });
      var url = `https://app.seekwell.io/data/${this.storeState.block.uuid}`;
      if (this.storeState.block.params.length > 0) {
        url = `${url}?`;
        for (
          let index = 0;
          index < this.storeState.block.params.length;
          index++
        ) {
          const p = this.storeState.block.params[index];
          url = `${url}${p.name}=${p.value}&`;
        }
        url = url.slice(0, url.length - 1);
      }
      this.storeState.shareUrl = url;
    },
    revokeShare() {
      this.storeState.cmdkActive = false;
      this.storeState.cmdkParentCmd = "shareBlock2";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      this.storeState.block.public = false;
      store.updateBlock({ gotBlock: true });
      this.storeState.snackbar = true;
      this.storeState.message = "Public access revoked";
    },
    shareBlockChildren() {
      let cmdks = [];
      var vm = this;
      let opts = [
        {
          label: `Share block with teammate`,
          include: "all",
          value: "shareWithTeam",
          search: "share,with,team",
          icon: "mdi-account-multiple-plus",
          f: function () {
            vm.shareWithTeam();
          },
        },
        {
          label: `Share table publicly`,
          include: "sql",
          value: "shareTable",
          search: "table,public",
          icon: "mdi-table",
          f: function () {
            vm.shareTable();
          },
        },
        {
          label: `Share chart publicly`,
          include: "sql",
          value: "shareChart",
          search: "chart,public",
          icon: "mdi-chart-bar",
          f: function (self) {
            vm.shareChart();
          },
        },
        {
          label: `Share / embed Story publicly`,
          include: "story",
          value: "shareStory",
          search: "table,public",
          icon: "mdi-file-document-box-plus-outline",
          f: function () {
            vm.shareStory();
          },
        },
      ];
      for (let i = 0; i < opts.length; i++) {
        let el = opts[i];
        let d = {
          cmd: `cmdkItem_${el.value}`,
          description: el.label,
          icon: el.icon || "mdi-alarm",
          parent: "shareBlock",
          search: el.search,
          children: true,
          f: el.f,
        };
        if (
          this.storeState.block.cellType === "story" &&
          el.include === "story"
        ) {
          cmdks.push(d);
        } else if (
          this.storeState.block.cellType != "story" &&
          el.include != "story"
        ) {
          cmdks.push(d);
        } else if (el.include === "all") {
          cmdks.push(d);
        }
      }
      let revoke = {
        cmd: `cmdkItem_revoke`,
        description: `Revoke public access`,
        icon: "mdi-close",
        search: "revoke,share",
        children: false,
        f: function () {
          vm.revokeShare();
        },
      };
      cmdks.push(revoke);
      return cmdks;
    },
    formActions() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "formActions";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      // if (!curPath.startsWith('/run')) {
      //   let blockId = store.uuidv4()
      //   this.storeState.newBlocks.push(blockId)
      //   this.$router.push({ name: 'Run', params: {id: blockId }}).catch(err => console.error(err))
      // }
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    formChildren() {
      let cmdks = [];
      var self = this;
      let opts = [
        {
          label: `View pending / approved`,
          value: "formViewPending",
          search: "view,pending",
          icon: "mdi-eye",
          f: function (self) {
            window.bus.$emit("updateThis", { k: "viewAll", v: false });
          },
        },
        {
          label: `View all`,
          value: "formViewArchived",
          search: "view,archived",
          icon: "mdi-eye",
          f: function (self) {
            window.bus.$emit("updateThis", { k: "viewAll", v: true });
          },
        },
        {
          label: `Archive all`,
          value: "archiveAll",
          search: "archive",
          icon: "mdi-eye",
          f: function (self) {
            window.bus.$emit("archiveAll", { ok: true });
          },
        },
        {
          label: `Back to main`,
          value: "backToMainForm",
          search: "back,main",
          icon: "mdi-chevron-left",
          f: this.goToBlocks,
        },
      ];
      for (let i = 0; i < opts.length; i++) {
        let el = opts[i];
        let d = {
          cmd: `cmdkItem_${el.value}`,
          description: el.label,
          icon: el.icon || "mdi-alarm",
          parent: "settings",
          search: el.search,
          f: el.f,
        };
        cmdks.push(d);
      }
      return cmdks;
    },
    useSnippetChildren() {
      let cmdks = [];
      var self = this;
      // iterate thru snippets in blocks
      for (let [key, block] of Object.entries(this.storeState.blocks)) {
        var cmdkSearch = block.title.replace(" ", ",");
        if (!cmdkSearch) {
          cmdkSearch = block.code;
        }
        if (block.cellType === "snippet" && block.code.length > 0) {
          let cmdk = {
            cmd: `cmdkItem_${block.uuid}`,
            description: block.title,
            detail: block.code,
            label: block.title,
            value: block.uuid,
            search: cmdkSearch,
            children: function () {},
            parent: "useSnippet",
            icon: false,
            f: function () {
              self.useSnippet2(block.uuid);
            },
          };
          cmdks.push(cmdk);
        }
      }
      if (cmdks.length === 0) {
        this.noSnippets = true;
      }
      return cmdks;
    },
    cancelImport() {
      this.storeState.autoImport.running = false;
      this.storeState.cmdkActive = false;
    },
    saveImportScheduleDb() {
      this.storeState.autoImport.running = false;
      this.storeState.cmdkActive = false;
      for (
        let index = 0;
        index < this.storeState.autoImport.tables.length;
        index++
      ) {
        const source = this.storeState.autoImport.tables[index];
        if (source.include) {
          let block = this.storeState.blocks[source.blockId];
          block.repeat = this.storeState.autoImport.repeat;
          Vue.set(this.storeState.blocks, block.uuid, block);
          store.updateBlock({ gotBlock: true, block: block });
        }
      }
    },
    saveImportSchedule() {
      this.storeState.autoImport.running = false;
      this.storeState.cmdkActive = false;
      for (
        let index = 0;
        index < this.storeState.autoImport.spreadSheetMetadata.sheets.length;
        index++
      ) {
        const sheet =
          this.storeState.autoImport.spreadSheetMetadata.sheets[index];
        if (sheet.include) {
          let block = this.storeState.blocks[sheet.blockId];
          block.repeat = this.storeState.autoImport.repeat;
          Vue.set(this.storeState.blocks, block.uuid, block);
          store.updateBlock({ gotBlock: true, block: block });
        }
      }
    },
    doneImportingDb() {
      this.storeState.autoImport.running = true;
      this.storeState.autoImport.success = false;
      for (
        let index = 0;
        index < this.storeState.autoImport.tables.length;
        index++
      ) {
        const source = this.storeState.autoImport.tables[index];
        if (source.include) {
          source.message = "";
          source.success = true;
          if (source.blockId) {
            var block = this.storeState.blocks[source.blockId];
          } else {
            var block = JSON.parse(
              JSON.stringify(this.storeState.blockTemplate)
            );
            block.uuid = store.uuidv4();

            block.tags.push({
              value: "autoimport",
              text: "autoimport",
            });
            block.tags.push({
              value: this.storeState.autoImport.ss_id,
              text: this.storeState.autoImport.ss_id,
            });
            block.code = `select * from ${source.schema}.${source.name}`;
            source.blockId = block.uuid;
          }
          block.source.uuid = this.storeState.autoImport.source.uuid;
          source.running = true;
          this.storeState.autoImport.tables[index] = source;
          block.title = `${source.name} (Import)`;
          block.destination.ss_id = this.storeState.autoImport.ss_id;
          block.destination.sheet = source.destName;
          block.destination.type = "sheets";
          block.destination.sheetsAppend = false;
          block.cellType = "sql";
          Vue.set(this.storeState.blocks, block.uuid, block);
          store.updateBlock({ gotBlock: true, block: block });
          store.runTempBlock(block, { importDb: true, autoImport: true });
        } else {
          source.message = "";
          source.success = true;
        }
      }
      this.$forceUpdate();
    },
    doneImporting() {
      this.storeState.autoImport.running = true;
      this.storeState.autoImport.success = false;
      for (
        let index = 0;
        index < this.storeState.autoImport.spreadSheetMetadata.sheets.length;
        index++
      ) {
        const sheet =
          this.storeState.autoImport.spreadSheetMetadata.sheets[index];
        if (sheet.include) {
          sheet.message = "";
          sheet.success = true;
          var sheetRange = sheet.properties.title;
          if (sheet.range && sheet.range.length > 0) {
            sheetRange += `!${sheet.range}`;
          }
          if (sheet.blockId) {
            var block = this.storeState.blocks[sheet.blockId];
            block.params = [
              {
                name: "sheet",
                type: "sheets",
                sheet: sheetRange,
                value: "",
                spreadSheet: this.storeState.autoImport.ss_id,
              },
            ];
          } else {
            var block = JSON.parse(
              JSON.stringify(this.storeState.blockTemplate)
            );
            block.uuid = store.uuidv4();
            block.params = [
              {
                name: "sheet",
                type: "sheets",
                sheet: sheetRange,
                value: "",
                spreadSheet: this.storeState.autoImport.ss_id,
              },
            ];
            block.tags.push({
              value: "autoimport",
              text: "autoimport",
            });
            block.tags.push({
              value: this.storeState.autoImport.ss_id,
              text: this.storeState.autoImport.ss_id,
            });
            block.code = `select * from {{sheet}}`;
            sheet.blockId = block.uuid;
          }
          sheet.running = true;
          this.storeState.autoImport.spreadSheetMetadata.sheets[index] = sheet;
          block.title = `${sheet.properties.title} (Import)`;
          block.destination.type = "database";
          block.destination.database = {
            operation: "create",
            table: `${sheet.table}`,
            uuid: `${this.storeState.autoImport.destination.uuid}`,
          };
          if (
            this.storeState.autoImport.schema.length > 0 &&
            !block.destination.database.table.includes(".")
          ) {
            block.destination.database.table = `${this.storeState.autoImport.schema}.${sheet.table}`;
          }
          block.source = {
            name: "Sheets",
            uuid: "googlesheets",
            type: "sql",
            sshUsername: "",
            unique_source: 0,
          };
          block.cellType = "sheetsAsSql";
          // this.storeState.blocks[block.uuid] = block
          Vue.set(this.storeState.blocks, block.uuid, block);
          store.updateBlock({ gotBlock: true, block: block });
          store.runTempBlock(block, { doDestinations: true, autoImport: true });
        } else {
          sheet.message = "";
          sheet.success = true;
        }
      }
    },
    doneWithSnippet() {
      let curPath = this.$route.path;
      if (curPath === "/" || curPath === "/blocks")
        this.newBlock({ snippet: this.storeState.cmdkForm.uuid });
      setTimeout(() => {
        window.bus.$emit("addSnippet", { block: this.storeState.cmdkForm });
      }, 200);
    },
    settingsChildren() {
      let cmdks = [];
      var self = this;
      let opts = [
        {
          label: `View profile`,
          value: "profile",
          search: "profile",
          icon: "mdi-account",
          f: function () {
            const url = `https://seekwell.io/profile?ref=web`;
            const win = window.open(url, "_blank");
            win.focus();
          },
        },
        {
          label: `Invite team member`,
          value: "invite",
          search: "invite",
          icon: "mdi-account-multiple-plus",
          f: function () {
            const url = `https://seekwell.io/profile?ref=web`;
            const win = window.open(url, "_blank");
            win.focus();
          },
        },
      ];
      for (let i = 0; i < opts.length; i++) {
        let el = opts[i];
        let d = {
          cmd: `cmdkItem_${el.value}`,
          description: el.label,
          icon: el.icon || "mdi-alarm",
          parent: "settings",
          search: el.search,
          f: el.f,
          keys: [
            {
              key: String(i),
            },
          ],
        };
        cmdks.push(d);
      }
      console.log(cmdks);
      // return cmdks.filter(o => o.search.includes(self.storeState.cmdkInput))
      return cmdks;
    },
    openLink() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "openLink";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    handleR() {
      if (this.$route.path === "/details") {
        this.addReminder();
      } else {
        this.goToRun();
      }
    },
    addReminder() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "addReminder";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    addReminder2(d) {
      console.log(d);
      this.storeState.cmdkActive = false;
    },
    openLinkChildren() {
      let cmdks = [];
      var self = this;
      let emailSettings = {
        subject: "Follow up",
        bcc: "5627699@bcc.hubspot.com",
        body: `Hey - I'm Mike, one of the founders of SeekWell.
        <br><br>
        We do 15 minute on-boarding sessions for customers we think are a good fit for us to get you setup quickly and ensure you're successful with SeekWell.
        <br><br>
        Please respond with a time that works for you or book a session at https://calendly.com/mikeritchie/15min`,
      };
      let domain = `https://www.${self.storeState.details.email.split("@")[1]}`;
      let opts = [
        {
          label: `Send email to ${self.storeState.details.email}`,
          value: "email",
          search: "email",
          icon: "mdi-email-send",
          f: function () {
            window.location.href = `mailto:${self.storeState.details.email}?bcc=${emailSettings.bcc}&subject=${emailSettings.subject}&body=${emailSettings.body}`;
          },
        },
        {
          label: `Search email for ${self.storeState.details.email}`,
          value: "searchEmail",
          search: "search,email",
          icon: "mdi-email-send",
          f: function () {
            const url = `https://mail.superhuman.com/search/${encodeURIComponent(
              self.storeState.details.email
            )}`;
            const win = window.open(url, "_blank");
            win.focus();
          },
        },
        {
          label: `Open ${domain}`,
          value: "domain",
          search: "domain",
          icon: "mdi-link",
          f: function () {
            var win = window.open(domain, "_blank");
            win.focus();
          },
        },
        {
          label: "Open in Intercom",
          value: "intercom",
          search: "intercom",
          icon: "mdi-message-processing-outline",
          f: this.openIntercom,
        },
        {
          label: "Open in Stripe",
          value: "stripe",
          search: "stripe",
          icon: "mdi-currency-usd",
          f: this.openStripe,
        },
        {
          label: "Search on LinkedIn",
          value: "linkedin",
          search: "linkedin",
          icon: "mdi-linkedin",
          f: function () {
            let url = `https://www.linkedin.com/search/results/companies/?keywords=${
              self.storeState.details.email.split("@")[1]
            }`;
            var win = window.open(url, "_blank");
            win.focus();
          },
        },
      ];
      for (let i = 0; i < opts.length; i++) {
        let el = opts[i];
        let d = {
          cmd: `cmdkItem_${el.value}`,
          description: el.label,
          icon: el.icon || "mdi-alarm",
          shortcut: i,
          parent: "addReminder",
          html: "<span>Expand</span>",
          search: el.search,
          f: el.f,
          keys: [
            {
              key: String(i),
            },
          ],
        };
        cmdks.push(d);
      }
      console.log(cmdks);
      // return cmdks.filter(o => o.search.includes(self.storeState.cmdkInput))
      return cmdks;
    },
    reminderChildren() {
      let cmdks = [];
      var self = this;
      let opts = [
        {
          label: `Today (${self.storeState.defaultTime.hour}:${self.storeState.defaultTime.minute})`,
          value: "today",
          search: "today",
          f: function () {
            return moment().set(self.storeState.defaultTime);
          },
        },
        {
          label: "Tomorrow",
          value: "tomorrow",
          search: "tomorrow",
          f: function () {
            return moment().add(1, "days").set(self.storeState.defaultTime);
          },
        },
        {
          label: "Monday",
          value: "monday",
          search: "monday",
          f: function () {
            const dayINeed = 1; // for Monday
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment()
                .isoWeekday(dayINeed)
                .set(self.storeState.defaultTime);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment()
                .add(1, "weeks")
                .isoWeekday(dayINeed)
                .set(self.storeState.defaultTime);
            }
          },
        },
        {
          label: "Tuesday",
          value: "tuesday",
          search: "tuesday",
          f: function () {
            const dayINeed = 2;
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment()
                .isoWeekday(dayINeed)
                .set(self.storeState.defaultTime);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment()
                .add(1, "weeks")
                .isoWeekday(dayINeed)
                .set(self.storeState.defaultTime);
            }
          },
        },
        {
          label: "Wednesday",
          value: "wednesday",
          search: "wednesday",
          f: function () {
            const dayINeed = 3;
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment().isoWeekday(dayINeed);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment().add(1, "weeks").isoWeekday(dayINeed);
            }
          },
        },
        {
          label: "Thursday",
          value: "thursday",
          search: "thursday",
          f: function () {
            const dayINeed = 4;
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment().isoWeekday(dayINeed);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment().add(1, "weeks").isoWeekday(dayINeed);
            }
          },
        },
        {
          label: "Friday",
          value: "friday",
          search: "friday",
          f: function () {
            const dayINeed = 5;
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment().isoWeekday(dayINeed);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment().add(1, "weeks").isoWeekday(dayINeed);
            }
          },
        },
        {
          label: "Saturday",
          value: "saturday",
          search: "saturday",
          f: function () {
            const dayINeed = 6;
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment().isoWeekday(dayINeed);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment().add(1, "weeks").isoWeekday(dayINeed);
            }
          },
        },
        {
          label: "Sunday",
          value: "sunday",
          search: "sunday",
          f: function () {
            const dayINeed = 7;
            const today = moment().isoWeekday();

            // if we haven't yet passed the day of the week that I need:
            if (today <= dayINeed) {
              // then just give me this week's instance of that day
              return moment().isoWeekday(dayINeed);
            } else {
              // otherwise, give me *next week's* instance of that same day
              return moment().add(1, "weeks").isoWeekday(dayINeed);
            }
          },
        },
        {
          label: "Next Week",
          value: "nextweek",
          search: "nextweek",
          f: function () {
            return moment().add(7, "days").set(self.storeState.defaultTime);
          },
        },
        {
          label: "Clear / remove reminder",
          value: "clear",
          search: "clear,remove,delete",
          icon: "mdi-close",
          f: function () {
            self.storeState.editableDetails.reminder = false;
            return false;
          },
        },
      ];
      for (let i = 0; i < opts.length; i++) {
        let el = opts[i];
        let d = {
          cmd: `cmdkItem_${el.value}`,
          description: el.label,
          icon: el.icon || "mdi-alarm",
          shortcut: i,
          parent: "addReminder",
          html: "<span>Expand</span>",
          search: el.search,
          f: el.f,
          keys: [
            {
              key: String(i),
            },
          ],
        };
        cmdks.push(d);
      }
      console.log(cmdks);
      // return cmdks.filter(o => o.search.includes(self.storeState.cmdkInput))
      return cmdks;
    },
    changeSource() {
      this.storeState.cmdkActive = false;
      let c = this.$children.find((c) => c.$refs.run);
      if (c && c.$refs && c.$refs.source) {
        setTimeout(() => {
          c.$refs.source.focus();
        }, 0);
      } else {
        this.$router.push({ path: "/sources" }).catch((err) => {});
      }
    },
    addIntegration() {
      this.$router
        .push({ name: "Integrations" })
        .catch((err) => console.error(err));
    },
    logout() {
      let url = "https://seekwell.io/logout";
      window.open(url, "_blank");
      // let url2 = 'https://seekwell.ngrok.io/logout'
      // window.open(url2, '_blank');
      localStorage.removeItem("sessionId");
      this.storeState.loading = true;
      this.storeState.cmdkActive = false;
      setTimeout(() => {
        this.storeState.loading = false;
        this.$router
          .push({ path: "/login" })
          .catch((err) => console.error(err));
      }, 3000);
      // win.focus();
    },
    openStripe() {
      let url = "https://dashboard.stripe.com/search?query=email%3A";
      url += this.storeState.details.email;
      var win = window.open(url, "_blank");
      win.focus();
    },
    openLinkedIn() {
      let url =
        "https://www.linkedin.com/search/results/companies/?keywords=zanui";
      url += this.storeState.details.email;
      var win = window.open(url, "_blank");
      win.focus();
    },
    updatePlan() {
      this.storeState.cmdkParentCmd = "updateUserPlan";
    },
    updatePlan2() {
      let d = {
        table: "users",
        model: "dummy_users",
        id: this.storeState.details.email,
        crud: "update",
        update: "plan",
        value: "pro",
      };
      this.updateUserData(d);
    },
    updateUserData(d) {
      const path = store.getPath("/soup_update_user_data");
      d.sessionId = this.storeState.sessionId;
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          self.storeState.cmdkActive = false;
          self.storeState.details.plan = "NEW";
          self.storeState.snackbar = true;
          self.storeState.message = "Updated!";
        })
        .catch((error) => {
          self.storeState.snackbar = true;
          self.storeState.message = error;
          console.error(error);
        });
    },
    userPlanChildren() {
      let opts = ["premium", "pro", "basic", "trial"];
      let cmdks = [];
      var self = this;
      for (let i = 0; i < opts.length; i++) {
        let el = opts[i];
        let d = {
          cmd: `updateUserPlan_${el}`,
          description: el,
          icon:
            ["trial", "basic"].indexOf(el) >= 0
              ? "mdi-emoticon-sad-outline"
              : "mdi-currency-usd",
          shortcut: i,
          html: "<span>Expand</span>",
          search: "archive,this",
          f: self.updatePlan2,
          keys: [
            {
              key: String(i),
            },
          ],
        };
        cmdks.push(d);
      }
      console.log(cmdks);
      return cmdks;
    },
    createTag() {
      console.log("createTag...");
      this.cmdkPlaceholder = "Tag Name";
      this.storeState.cmdkInput = "";
      this.storeState.cmdkParentCmd = "createTag";
      self.storeState.addingTag = true;
      return false;
    },
    createTagChildren() {
      return [
        {
          cmd: `saveTag`,
          description: "Press enter to save the tag",
          icon: "mdi-content-save-outline",
          search: "save,this",
          f: this.saveTag,
        },
      ];
    },
    saveTag() {
      this.storeState.cmdkParentCmd = false;
      let newTag = {
        value: store.uuidv4(),
        text: this.storeState.cmdkInput.trim(),
      };
      this.storeState.block.tags.push(newTag);
      this.storeState.addingTag = false;
      this.storeState.cmdkActive = false;
    },
    createQueue() {
      console.log("createQueue...");
      this.createQueueChildren();
      return false;
    },
    createQueueChildren() {
      let searching =
        this.storeState.currentFocus === "search" ||
        this.$route.path === "/search";
      if (!searching)
        this.$router
          .push({ path: "/search" })
          .catch((err) => console.error(err));
      this.cmdkPlaceholder = "Queue Name";
      this.storeState.cmdkParentCmd = "createQueue";
      return [
        {
          cmd: `saveQueue`,
          description: "Press enter to save the queue",
          icon: "mdi-content-save-outline",
          search: "save,this",
          f: this.saveQueue,
        },
      ];
    },
    saveQueue() {
      let qId =
        Math.max.apply(
          Math,
          this.storeState.settings.team.queues.map(function (o) {
            return o.id;
          })
        ) + 1;
      console.log("new qId:", qId);
      let q = {
        id: qId,
        name: this.storeState.cmdkInput,
        query: this.storeState.searchTerm,
      };
      this.storeState.settings.team.queues.push(q);
      this.updateSettings();
      this.storeState.cmdkActive = false;
      console.log("queues", this.storeState.settings.team.queues);
      this.$router
        .push({ name: "Queues", params: { id: qId } })
        .catch((err) => console.error(err));
    },
    getEvents() {
      let opts = {
        sql: `
          SELECT *
          FROM events as e
          WHERE e.email = '${this.storeState.details.email}'
          ORDER BY last_event_dt DESC
          `,
        subType: "events",
      };
      this.getTable(opts);
    },
    getTable(opts) {
      this.storeState.cmdkActive = false;
      var self = this;
      execSql(this.storeState.db, opts.sql, "", successHandler, errorHandler);
      function successHandler(tx, results) {
        var arr = [];
        console.log("found: ", results.rows.length);
        if (results.rows.length === 0) {
          self.storeState.snackbar = true;
          self.storeState.message = "No data.";
        }
        for (let i = 0; i < results.rows.length; i++) {
          let row = results.rows.item([i]);
          arr.push(row);
        }
        var cols = Object.keys(arr[0]);
        var tableHeaders = [];
        for (let i = 0; i < cols.length; i++) {
          let row = {
            text: cols[i],
            align: "left",
            sortable: false,
            value: cols[i],
          };
          tableHeaders.push(row);
        }
        console.log("tableHeaders: ", tableHeaders);
        self.storeState.details = {
          email: self.storeState.details.email,
          tableHeaders: tableHeaders,
          table: arr,
          type: "table",
          subType: opts.subType,
          reminder: false,
        };
        this.$router.push({ path: "/table" }).catch((err) => {});
        self.$forceUpdate();
      }
      function errorHandler(transaction, error) {
        console.log(`Error : ${error.message}`);
      }
      function execSql(db, sql, q, successHandler, errorHandler) {
        db.transaction(function (tx) {
          tx.executeSql(sql, [], successHandler, errorHandler);
        });
      }
    },
    viewSchedules() {
      this.storeState.cmdkActive = false;
      var self = this;
      function successHandler(tx, results) {
        var arr = [];
        console.log("found: ", results.rows.length);
        if (results.rows.length === 0) {
          self.storeState.snackbar = true;
          self.storeState.message = "No data.";
        }
        for (let i = 0; i < results.rows.length; i++) {
          let row = results.rows.item([i]);
          arr.push(row);
        }
        var cols = Object.keys(arr[0]);
        var tableHeaders = [];
        for (let i = 0; i < cols.length; i++) {
          let row = {
            text: cols[i],
            align: "left",
            sortable: false,
            value: cols[i],
          };
          tableHeaders.push(row);
        }
        console.log("tableHeaders: ", tableHeaders);
        console.log("table: ", arr);
        self.storeState.details = {
          email: self.storeState.details.email,
          tableHeaders: tableHeaders,
          table: arr,
          type: "table",
          subType: "schedules",
          reminder: false,
        };
        // this.$router.push({ path: '/details' }).catch(err => {})
        self.$forceUpdate();
      }
      function errorHandler(transaction, error) {
        console.log(`Error : ${error.message}`);
      }
      function execSql(db, sql, q, successHandler, errorHandler) {
        db.transaction(function (tx) {
          tx.executeSql(sql, [], successHandler, errorHandler);
        });
      }
      // execSql(this.storeState.db, `SELECT * FROM users WHERE users MATCH '${this.searchTerm}' LIMIT 20`, '', successHandler)
      let sql = `
        SELECT * 
        FROM schedules 
        WHERE LOWER(email) = '${self.storeState.details.email}' 
        ORDER BY schedule_id DESC LIMIT 100
        `;
      execSql(this.storeState.db, sql, "", successHandler, errorHandler);
    },
    openBlock(blockId) {
      this.storeState.cmdkActive = false;
      let block = this.storeState.blocks[blockId];
      if (!block) {
        this.$router
          .push({ name: "Run", params: { id: blockId } })
          .catch((err) => console.error(err));
        return;
      }
      if (block.cellType === "doc") {
        this.$router
          .push({ name: "Docs", params: { id: blockId } })
          .catch((err) => console.error(err));
      } else if (block.cellType === "snippet") {
        this.$router
          .push({ name: "Run", params: { id: blockId, snippet: true } })
          .catch((err) => console.error(err));
      } else if (block.set && block.set.type === "explore") {
        this.$router
          .push({ name: "Sets", params: { id: blockId } })
          .catch((err) => console.error(err));
      } else if (block.cellType === "story") {
        this.$router
          .push({ name: "Run", params: { id: blockId } })
          .catch((err) => console.error(err));
      } else if (block.cellType === "doc") {
        this.$router
          .push({ name: "Docs", params: { id: blockId } })
          .catch((err) => console.error(err));
      } else {
        this.$router
          .push({ name: "Run", params: { id: blockId } })
          .catch((err) => console.error(err));
      }
    },
    openSoupDetails(o, index) {
      if (!this.storeState.soupResults) return;
      this.changeFocus("details", this);
      this.storeState.details = this.storeState.soupResults[index];
      if (!this.storeState.details) return;
      let detail_type = "users";
      let detail_id = this.storeState.details.email;
      if (this.storeState.editableDetailsAll[`${detail_type}-${detail_id}`]) {
        this.storeState.editableDetails =
          this.storeState.editableDetailsAll[`${detail_type}-${detail_id}`];
      } else {
        this.storeState.editableDetails = JSON.parse(
          JSON.stringify(this.storeState.editableDetailsShell)
        );
        this.updateEditableDetails(detail_id, detail_type);
      }
      // this.editableDetails.reminder = false;
      this.storeState.details.type = "card";
      this.$router.push({ path: "/details" }).catch((err) => {});
    },
    openDetails(o, index) {
      this.changeFocus("details", this);
      this.storeState.details = this.storeState.searchResults[index];
      let detail_type = "users";
      let detail_id = this.storeState.details.email;
      if (this.storeState.editableDetailsAll[`${detail_type}-${detail_id}`]) {
        this.storeState.editableDetails =
          this.storeState.editableDetailsAll[`${detail_type}-${detail_id}`];
      } else {
        this.storeState.editableDetails = JSON.parse(
          JSON.stringify(this.storeState.editableDetailsShell)
        );
        this.updateEditableDetails(detail_id, detail_type);
      }
      // this.editableDetails.reminder = false;
      this.storeState.details.type = "card";
      this.$router.push({ path: "/details" }).catch((err) => {});
    },
    changeFocus(newFocus, self) {
      if (newFocus === self.storeState.currentFocus) return;
      if (newFocus === "cmdk") return;
      self.storeState.previousFocus = self.storeState.currentFocus;
      self.storeState.currentFocus = newFocus;
    },
    slash(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      this.storeState.searching = true;
      let curPath = this.$route.path;
      if (curPath.startsWith("/blocks") || curPath === "/") {
        setTimeout(() => {
          let c = this.$children.find((c) => c.$refs.blocks);
          if (c.$refs.blockSearch) c.$refs.blockSearch.focus();
        }, 0);
        // window.bus.$emit('focusEl',
        //   {el: 'blockSearch'}
        // )
        return;
      }
      this.$router.push({ path: "/search" }).catch((err) => {});
      this.storeState.searchIndex = 0;
      window.bus.$emit("focusEl", { el: "searchText" });
      if (e && e.preventDefault) e.preventDefault();
      console.log("///////");
    },
    switchSource(e) {
      this.storeState.cmdkActive = false;
      this.$router.push({ path: "/sources" }).catch((err) => {});
    },
    usageReport(e) {
      this.storeState.cmdkActive = false;
      this.$router.push({ path: "/usage" }).catch((err) => {});
    },
    shareTwitter() {
      let url =
        "https://twitter.com/intent/tweet?text=Getting%20%23analytics%20done%20with%20%40SeekWell_io!";
      url +=
        "%20Check%20it%20out%20at%20https%3A%2F%2Fseekwell.io%2F&amp;related=SeekWell_io,mike_seekwell&amp;url=blank";
      var win = window.open(url, "_blank");
      win.focus();
    },
    openPivotTable() {
      this.storeState.cmdkParentCmd = "pivotTable";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      this.storeState.cmdkActive = true;
      if (!this.storeState.block.pivot.active) {
        this.storeState.block.pivot.active = true;
        this.storeState.block.pivot.origHeaders = JSON.parse(
          JSON.stringify(this.storeState.block.results.headers)
        );
      }
    },
    removePivotTable() {
      this.storeState.block.pivot.active = false;
    },
    sendInvite() {
      this.storeState.cmdkParentCmd = "sendInvite";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      this.storeState.cmdkActive = true;
    },
    sendInvite2() {
      console.log("sendInvite2");
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "sendInvite2";
      this.sendingInvites = true;
      store.sendInvites({ invited: this.storeState.invites });
      this.storeState.invites = [""];
    },
    sendInviteChildren() {
      let cmdks = [];
      return cmdks;
    },
    sendInviteChildren2() {
      let cmdks = [];
      return cmdks;
    },
    markDone(e) {
      // this.changeFocus('search')
      // this.storeState.cmdkActive = false
      // this.goBack()
      // let done = this.storeState.editableDetails.tags.find(t => t.text === 'done')
      // if (!done) this.storeState.editableDetails.tags.push({value: 'owvj0wj089233', text: 'done'})
      // if (e && e.preventDefault) e.preventDefault()
    },
    newWindow() {
      let routeData = this.$router.resolve({
        name: "Run",
        params: { id: "new" },
      });
      window.open(routeData.href, "_blank");
      this.storeState.cmdkActive = false;
    },
    newBlock(opts) {
      if (!opts) opts = {};
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      if (opts.snippet) {
        let snippetBlock = JSON.parse(
          JSON.stringify(this.storeState.blocks[opts.snippet])
        );
        snippetBlock.title = "";
        snippetBlock.tags = [];
        snippetBlock.uuid = blockId;
        snippetBlock.cellType = "sql";
        this.storeState.blocks[blockId] = snippetBlock;
      }
      this.$router
        .push({ name: "Run", params: { id: blockId, snippet: opts.snippet } })
        .catch((err) => console.error(err));
      let self = this;
      setTimeout(() => {
        let c = this.$children.find((c) => c.$refs.run);
        if (c.$refs.source) c.$refs.source.focus();
      }, 0);
    },
    goToBlocks(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      this.$router.push({ name: "Blocks" }).catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    goToStories(e) {
      // this.changeFocus('search')
      this.storeState.activeQueue = 5;
      this.$router.push({ name: "Blocks" }).catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    goToScheduled(e) {
      // this.changeFocus('search')
      this.storeState.activeQueue = 6;
      this.$router.push({ name: "Blocks" }).catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    closeCmdk() {
      this.storeState.cmdkActive = false;
      this.storeState.cmdkParentCmd = false;
      this.storeState.cmdkForm = false;
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      this.storeState.searchTerm = "";
      this.storeState.justClosedCmdk = false;
    },
    goToSnippets(e) {
      this.storeState.cmdkActive = false;
      this.storeState.cmdkParentCmd = false;
      this.storeState.cmdkForm = false;
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      this.storeState.searchTerm = "#snippet ";
      this.$router.push({ name: "Search" }).catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    goToSets(e) {
      // this.changeFocus('search')
      this.storeState.activeQueue = 4;
      this.$router.push({ name: "Blocks" }).catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    goToQueues(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      this.$router
        .push({ name: "Soup", params: { queue: 0 } })
        .catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    goToSoup(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      this.$router.push({ name: "Soup" }).catch((err) => console.error(err));
      if (e && e.preventDefault) e.preventDefault();
    },
    updateEmailSender() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "updateEmailSender";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    updateEmailSender2(email) {
      this.storeState.block.emailOverrideSender = email;
    },
    restoreFromTrash(blockId) {
      Vue.set(this.storeState.blocks, blockId, this.storeState.trash[blockId]);
      Vue.set(this.storeState.blocks[blockId], "deleted", false);
      store.updateBlock({
        gotBlock: true,
        block: this.storeState.trash[blockId],
      });
      Vue.delete(this.storeState.trash, blockId);
      console.log("restore...");
    },
    createTablesFromSheet() {
      this.storeState.autoImport = JSON.parse(
        JSON.stringify(this.storeState.autoImportTemplate)
      );
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "createTablesFromSheet";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    autoImportToSheets() {
      this.storeState.autoImport = JSON.parse(
        JSON.stringify(this.storeState.autoImportTemplate)
      );
      // this.storeState.autoImport.source = JSON.parse(JSON.stringify(this.storeState.blockTemplate.source))
      // this.storeState.autoImport.destination = JSON.parse(JSON.stringify(this.storeState.blockTemplate.destination))
      if (this.storeState.dbMeta && this.storeState.dbMeta.schemaTables) {
        this.storeState.autoImport.tables = JSON.parse(
          JSON.stringify(this.storeState.dbMeta.schemaTables)
        );
      }
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "autoImportToSheets";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    getTrash() {
      this.storeState.cmdkActive = true;
      this.storeState.gettingTrash = true;
      this.getSoupBlocks({ trash: "true", rowLimit: 1000 });
      this.storeState.cmdkParentCmd = "trash";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    updateUserRolesPermissions() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "updateUserRolesPermissions";
      this.storeState.currentFocus = "cmdk";
      this.storeState.cmdkInput = "";
      this.storeState.searchIndex = 0;
      let curPath = this.$route.path;
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    updateUserRolesPermissions2() {
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = "updateUserRolesPermissions2";
    },
    updateUserRolesPermissionsChildren() {
      let cmdks = [];
      var self = this;
      for (
        let index = 0;
        index < this.storeState.settings.team.members.length;
        index++
      ) {
        const member = this.storeState.settings.team.members[index];
        let cmdk = {
          cmd: `cmdkItem_${member.email}_${index}`,
          description: `${member.email} (${member.role})`,
          detail: member.email,
          label: member.email,
          value: member.email,
          search: member.email,
          children: function () {},
          parent: "updateEmailSender",
          icon: member.pic,
          f: function () {
            self.updateUserRolesPermissions2(member);
          },
        };
        cmdks.push(cmdk);
      }
      return cmdks;
    },
    updateEmailSenderChildren() {
      let cmdks = [];
      var self = this;
      for (
        let index = 0;
        index < this.storeState.settings.team.members.length;
        index++
      ) {
        const member = this.storeState.settings.team.members[index];
        let cmdk = {
          cmd: `cmdkItem_${member.email}`,
          description: member.email,
          detail: member.email,
          label: member.email,
          value: member.email,
          search: member.email,
          children: function () {},
          parent: "updateEmailSender",
          icon: member.pic,
          f: function () {
            self.updateUserRolesPermissions2(member.email);
          },
        };
        cmdks.push(cmdk);
      }
      return cmdks;
    },
    flipToPython(e) {
      this.storeState.block.cellType = "python";
    },
    changeViewNumber(e) {
      if (!e) return;
      let keyNum = Number(e.key);
      if (!keyNum) return;
      this.storeState.viewNumber = keyNum;
    },
    toggleView(e) {
      // this.changeFocus('search')
      if (this.storeState.currentFocus === "code") return;
      if (e && e.preventDefault) e.preventDefault();
      this.storeState.runView =
        this.storeState.runView + 1 === this.storeState.runViews.length
          ? 0
          : this.storeState.runView + 1;
    },
    goToRun(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      this.$router
        .push({ name: "Run", params: { id: blockId } })
        .catch((err) => console.error(err));
      let self = this;
      setTimeout(() => {
        let c = self.$children.find((c) => c.$refs.run);
        if (c.$refs.source) c.$refs.source.focus();
      }, 0);
      if (e && e.preventDefault) e.preventDefault();
    },
    goToForm(e) {
      this.storeState.cmdkActive = false;
      this.$router
        .push({ name: "Form", params: { id: this.storeState.block.uuid } })
        .catch((err) => console.error(err));
    },
    goToTables(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      this.$router
        .push({ name: "Tables", params: { id: blockId } })
        .catch((err) => console.error(err));
      let self = this;
      if (e && e.preventDefault) e.preventDefault();
    },
    exploreSets(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      this.$router
        .push({ name: "Sets", params: { id: blockId } })
        .catch((err) => console.error(err));
      let self = this;
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault();
    },
    createStory(e) {
      // this.changeFocus('search')
      this.storeState.cmdkActive = false;
      let blockId = store.uuidv4();
      this.storeState.newBlocks.push(blockId);
      this.$router
        .push({ name: "Run", params: { id: blockId, cellType: "story" } })
        .catch((err) => console.error(err));
      let self = this;
      setTimeout(() => {
        // let c = self.$children.find(c => c.$refs.run)
        // c.$refs.source.focus()
      }, 0);
      if (e && e.preventDefault) e.preventDefault();
    },
    emitUp() {
      console.log("emitup: ");
    },
    openCmdK(e) {
      console.log("openCmdK: ", e);
      if (e && e.preventDefault) e.preventDefault();
      this.storeState.currentFocus = "cmdk";
      this.storeState.searchIndex = 0;
      this.storeState.cmdkActive = true;
      this.storeState.cmdkParentCmd = e.cmdkParentCmd || false;
      this.storeState.cmdkInput = e.cmdkInput || "";
      setTimeout(() => {
        if (this.$refs.cmdkInput) this.$refs.cmdkInput.focus();
      }, 0);
    },
    blockHistoryNavBack(cm) {
      console.log("blockHistoryNavBack");
      let histLen = this.storeState.blockHistory.length - 1;
      if (this.storeState.blockHistoryPosition < histLen) {
        this.storeState.blockHistoryPosition += 1;
      } else {
        this.storeState.blockHistoryPosition = 0;
      }
      let blockId =
        this.storeState.blockHistory[this.storeState.blockHistoryPosition].uuid;
      this.$router
        .push({ name: "Run", params: { id: blockId } })
        .catch((err) => console.error(err));
    },
    blockHistoryNavForward(cm) {
      console.log(
        "blockHistoryNavForward1",
        this.storeState.blockHistoryPosition
      );
      let histLen = this.storeState.blockHistory.length - 1;
      if (this.storeState.blockHistoryPosition > 0) {
        this.storeState.blockHistoryPosition -= 1;
      } else {
        this.storeState.snackbar = true;
        this.storeState.message = `You're on the first block`;
        return;
      }
      console.log(
        "blockHistoryNavForward2",
        this.storeState.blockHistoryPosition
      );
      let blockId =
        this.storeState.blockHistory[this.storeState.blockHistoryPosition].uuid;
      console.log("blockHistoryNavForward2", blockId);
      this.$router
        .push({ name: "Run", params: { id: blockId } })
        .catch((err) => console.error(err));
    },
    upDown(e) {
      e.preventDefault();
      let curPath = this.$route.path;
      let searching =
        this.storeState.currentFocus === "search" ||
        curPath === "/search" ||
        curPath.startsWith("/queues");
      if (this.storeState.cmdkActive) {
        var filtLen = this.cmdkFiltered.length;
      } else if (curPath.startsWith("/run")) {
        var filtLen = this.storeState.compositionSuggestions.length;
      } else if (curPath.startsWith("/blocks") || curPath === "/") {
        var filtLen = Object.keys(this.storeState.blockResults).length;
      } else if (searching && !this.storeState.cmdkActive) {
        var filtLen = this.storeState.searchSuggestions.length;
      } else if (curPath.startsWith("/sets")) {
        var filtLen = this.storeState.searchSuggestions.length;
      } else if (curPath.startsWith("/soup")) {
        var filtLen = this.storeState.soupResults.length;
      } else if (curPath.startsWith("/tables")) {
        var filtLen = this.storeState.searchSuggestions.length;
      } else {
        var filtLen = this.storeState.searchSuggestions.length;
      }
      if (e.keyCode === 40) {
        //down
        if (this.storeState.searchIndex + 1 < filtLen) {
          this.storeState.searchIndex += 1;
        } else {
          this.storeState.searchIndex = 0;
        }
      } else {
        if (this.storeState.searchIndex > 0) {
          this.storeState.searchIndex -= 1;
        } else {
          this.storeState.searchIndex = filtLen - 1;
        }
      }
    },
    cmdEnter(e) {
      var self = this;
      let curPath = this.$route.path;
      if (
        self.storeState.cmdkActive &&
        self.storeState.cmdkForm &&
        self.storeState.cmdkParentCmd === "useSnippet"
      ) {
        if (curPath === "/" || curPath === "/blocks")
          this.newBlock({ snippet: self.storeState.cmdkForm.uuid });
        setTimeout(() => {
          window.bus.$emit("addSnippet", { block: self.storeState.cmdkForm });
        }, 200);
      } else if (
        self.storeState.cmdkActive &&
        self.storeState.cmdkParentCmd === "pivotTable"
      ) {
        if (curPath === "/" || curPath === "/blocks") this.newBlock();
        self.storeState.cmdkActive = false;
        store.runCode({});
      } else if (self.storeState.currentFocus === "editingComment") {
        console.log(self.storeState.editingComment);
        self.storeState.editingComment.disabled = true;
      } else if (this.$route.path.startsWith("/docs")) {
        let c = this.$children.find((c) => c.$refs.docs);
        if (c) c.refreshData();
      } else if (this.$route.path.startsWith("/run")) {
        if (
          this.storeState.block.set &&
          this.storeState.block.set.type === "json"
        ) {
          let code = store.generateSetSql({ test: true });
          store.runSet({ code: code });
        } else {
          store.runCode({});
        }
      } else if (this.$route.path.startsWith("/form")) {
        let c = this.$children.find((c) => c.$refs.form);
        // if (c) c.submitForm()
      } else if (this.$route.path.startsWith("/tables")) {
        this.storeState.block.code = store.generateMetaSql2(
          this.storeState.block.tables
        );
        store.runCode({});
      } else if (this.$route.path.startsWith("/sets")) {
        store.runSet({});
      }
    },
    handleTab(e) {
      let searching =
        this.storeState.currentFocus === "search" ||
        this.$route.path === "/search";
      if (searching && this.storeState.suggestedTagDetails) {
        e.preventDefault();
        console.log(
          "self.storeState.suggestedTag",
          this.storeState.suggestedTagDetails
        );
        var st = this.storeState.searchTerm.slice(
          0,
          this.storeState.suggestedTagDetails.start
        );
        let hashLoc = st.lastIndexOf("#");
        st = st.slice(0, hashLoc) + this.storeState.suggestedTagDetails.tag;
        st += this.storeState.searchTerm.slice(
          this.storeState.suggestedTagDetails.start
        );
        this.storeState.searchTerm = st;
        this.storeState.suggestedTagDetails = false;
      } else if (this.$route.path.startsWith("/queues")) {
        e.preventDefault();
        this.storeState.activeQueue += 1;
      } else if (searching && this.storeState.suggestedReminderDetails) {
        e.preventDefault();
        console.log(
          "self.storeState.suggestedTag",
          this.storeState.suggestedReminderDetails
        );
        var st = this.storeState.searchTerm.slice(
          0,
          this.storeState.suggestedReminderDetails.start
        );
        let hashLoc = st.lastIndexOf("!");
        st =
          st.slice(0, hashLoc) +
          this.storeState.suggestedReminderDetails.reminder;
        st += this.storeState.searchTerm.slice(
          this.storeState.suggestedReminderDetails.start
        );
        this.storeState.searchTerm = st;
        this.storeState.suggestedReminderDetails = false;
      }
    },
    handleEnter(e) {
      var r = "";
      let curPath = this.$route.path;
      var self = this;
      let searching =
        this.storeState.currentFocus === "search" ||
        this.$route.path === "/search";
      if (self.storeState.cmdkActive && self.storeState.cmdkForm) {
        // if (curPath === '/') this.newBlock()
        // setTimeout(() => {
        //   window.bus.$emit('addSnippet',
        //     {block: self.storeState.cmdkForm}
        //   )
        // }, 200);
      } else if (
        self.storeState.cmdkActive &&
        ["createTablesFromSheet", "autoImportToSheets"].includes(
          self.storeState.cmdkParentCmd
        )
      ) {
        //
      } else if (self.storeState.cmdkActive) {
        e.preventDefault();
        r = self.$refs["cmdkItem_" + self.storeState.searchIndex];
        var cmd = self.cmdkFiltered.find((o) => o.cmd === r[0].id);
        self.cmdkData = self.storeState.details;
        console.log("cmd...", cmd);
        if (cmd && cmd.parent && cmd.parent === "addReminder") {
          self.changeFocus("details", this);
          let c = cmd.cmd.replace("cmdkItem_", "");
          self.storeState.editableDetails.reminder = cmd.f().toISOString();
          self.$children.find((o) => o.$el.id === "details").$forceUpdate();
        } else if (this.storeState.cmdkParentCmd === "createTag") {
          this.storeState.cmdkParentCmd = false;
          let newTag = {
            value: store.uuidv4(),
            text: this.storeState.cmdkInput.trim(),
          };
          self.storeState.block.tags.push(newTag);
          self.storeState.addingTag = false;
          self.storeState.cmdkActive = false;
        } else if (cmd) {
          cmd.f();
        }
        if (cmd && cmd.children) {
          // cmd.children()
        } else {
          self.storeState.cmdkActive = false;
        }
      } else if (curPath.startsWith("/blocks") || curPath === "/") {
        e.preventDefault();
        let c = self.$children.find((c) => c.$refs.blocks);
        r = c.$refs["block_" + self.storeState.searchIndex];
        if (r && r[0] && r[0].dataset) self.openBlock(r[0].dataset.uuid);
        // } else if (curPath.startsWith('/run') && !self.storeState.addingTag && !self.storeState.cmdkActive) {
        //   e.preventDefault();
        //   let c = self.$children.find(c => c.$refs.run)
        //   if (c.$refs.cm) c.$refs.cm.codemirror.focus()
        //   return
      } else if (curPath.startsWith("/sets")) {
        e.preventDefault();
      } else if (curPath.startsWith("/soup")) {
        e.preventDefault();
      } else if (curPath.startsWith("/tables")) {
        e.preventDefault();
      } else if (self.storeState.tagActive) {
        return;
      } else if (searching && !self.storeState.cmdkActive) {
        e.preventDefault();
        // self.openDetails(r, self.storeState.searchIndex)
        let suggestion =
          self.storeState.searchSuggestions[self.storeState.searchIndex];
        if (suggestion.type === "code") {
          this.openBlock(suggestion.uuid);
          return;
        } else if (suggestion.type === "snippet") {
          this.openBlock(suggestion.uuid);
          return;
        }
        let sql = store.generateMetaSql(suggestion);
        this.storeState.block = JSON.parse(
          JSON.stringify(this.storeState.blockTemplate)
        );
        this.storeState.block.uuid = store.uuidv4();
        this.storeState.block.code = sql;
        this.storeState.block.queryBuilder = true;
        this.storeState.block.source.uuid =
          self.storeState.defaultSource.block_uuid;
        store.runTempBlock(this.storeState.block, {});
      }
    },
    moment: function () {
      return moment();
    },
    getUserData(opts) {
      console.log("getUserData");
      let rowLimit = false;
      let curPath = this.$route.path;
      if (opts && opts.rowLimit) rowLimit = opts.rowLimit;
      if (curPath.startsWith("/data")) {
        console.log("curPath: ", curPath);
        this.storeState.loading = false;
        this.getOneBlockFromFlask();
        return;
      } else if (
        !this.storeState.sessionId &&
        localStorage.sessionId &&
        localStorage.sessionId != "undefined" &&
        localStorage.sessionId.length > 200
      ) {
        this.storeState.sessionId = localStorage.sessionId;
      } else if (curPath.startsWith("/login") && !this.storeState.sessionId) {
        this.storeState.loading = true;
        return;
      } else if (!this.storeState.sessionId) {
        console.log("in elseeeeee");
        this.storeState.loading = true;
        return this.$router.push({ path: "/login" });
      }
      var self = this;
      // self.getOneBlockFromFlask()
      self.getSoupSources();
      self.getSoupBlocks({
        rowLimit: rowLimit || self.storeState.firstBlockGetLimit,
      });
      self.getSoupSchedules({
        rowLimit: rowLimit || self.storeState.firstBlockGetLimit,
      });
      self.getSoupDetails();
      self.getSoupSettings();
      self.getSoupSheets();
      // self.getWorkbooks()
      self.getGoogleDriveWorkbooks();
      self.getSoupSlack();
      self.getSoupIntercom();
      self.getSoupZoho();
      self.getSoupHubspot();
      self.getSoupSfdc();
      self.getSoupSfdcMetadata({ all: false });
      self.getSoupApps();
      self.getSoupAdmin();
      self.getSoupFeed({ rows: 500 });
      self.getIntegrations();
      self.getTeamsChallens();
      self.getSoupDriftFields();
      self.getSoupCloseFields();
      self.getUsageReport();
    },
    getIntegrations(opts) {
      const path = store.getPath("/soup_get_integrations");
      let d = { sessionId: this.storeState.sessionId, opts: opts };
      var self = this;
      // self.storeState.gotIntegrations = false
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.integrationCatalog = res.data.data;
            self.storeState.gotIntegrations = true;
            console.log(
              "soup_get_integrations: ",
              self.storeState.integrationCatalog
            );
          }
        })
        .catch((error) => {
          // this.storeState.snackbar = true;
          // this.storeState.message = error;
          console.error(error);
        });
    },

    getUsageReport() {
      const path = store.getPath("/usage_report");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      self.storeState.gotUsageReport = false;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.usageReport = res.data.report;
            self.storeState.gotUsageReport = true;
            self.storeState.monthlyRuns = res.data.total_runs;
            self.storeState.user_domain = res.data.user_domain;
            self.storeState.plan_runs = res.data.plan_runs;
            self.storeState.user_plan = res.data.user_plan;
            console.log("usage_report: ", self.storeState.usageReport);
          }
        })
        .catch((error) => {
          // this.storeState.snackbar = true;
          // this.storeState.message = error;
          console.error(error);
        });
    },
    getSoupFeed(opts) {
      const path = store.getPath("/soup_get_feed");
      let d = { sessionId: this.storeState.sessionId, opts: opts };
      var self = this;
      self.storeState.gotFeed = false;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.feed = res.data.data;
            self.storeState.gotFeed = true;
            console.log("soup_get_feed: ", self.storeState.feed);
          }
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSoupAdmin() {
      const path = store.getPath("/soup_get_user_data");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          self.storeState.loading = false;
          if (res.data.ok) {
            // self.model.users = res.data[0].data
            self.storeState.dataModel = res.data.data;
          }
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getTaggedModels(self) {
      // let dataModelBlocks = []
      let dataModelBlocks = {};
      for (let [key, value] of Object.entries(self.storeState.blocks)) {
        if (value.set && value.set.type === "sql") {
          let set = {
            name: value.title,
            block_uuid: key,
            db_type: "set",
            type: "set",
            setJsonId: value.set.json,
          };
          self.storeState.sets.push(set);
        }
        if (value.tags.length > 0) {
          let model = value.tags.find((t) => t.type === "model");
          if (model) {
            let modelName = model.name.replace("model:", "");
            dataModelBlocks[modelName] = value;
            value.model = modelName;
            let modelCmdk = {
              cmd: `runModel-${modelName}`,
              description: `Run ${modelName} model`,
              icon: "mdi-play",
              search: `model,run,get,${modelName}`,
              model: value,
              f: self.runModelFromCmdk,
            };
            self.cmdks.push(modelCmdk);
            var setJsonId = false;
            for (let [key2, value2] of Object.entries(self.storeState.blocks)) {
              if (value2.source.uuid === key) {
                setJsonId = key2;
              }
            }
            if (localStorage.dataModel) {
              let localModel = JSON.parse(localStorage.dataModel);
              if (localModel[value.model]) {
                self.storeState.dataModel[value.model] =
                  localModel[value.model];
              }
              if (modelName === "users" || self.storeState.forceFullRefresh) {
                store.runDataModel(value);
              }
            } else {
              store.runDataModel(value);
            }
          }
        }
      }
      self.storeState.dataModelBlocks = dataModelBlocks;
    },
    getSoupDetails() {
      const path = store.getPath("/soup_get_details");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (!res.data.ok) return;
          self.storeState.editableDetailsAll = res.data.data;
          // self.storeState.dataModel = res.data.data
          let keys = Object.keys(res.data.data);
          let detail_type = "users";
          let data_type = "tag";
          let details = [];
          for (let i = 0; i < keys.length; i++) {
            let row = res.data.data[keys[i]];
            if (row.reminder)
              details.push({
                data_id: keys[i],
                category: "reminder",
                data_key: "reminder",
                data_value: row.reminder,
              });
            for (let i2 = 0; i2 < row.tags.length; i2++) {
              let tag = row.tags[i2];
              details.push({
                data_id: keys[i],
                category: "tag",
                data_key: tag.text,
                data_value: tag.data || "",
              });
            }
          }
          // self.initWebSql(details, 'details')
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getJoinSuggestions(blocks) {
      for (const blockId in blocks) {
        let block = this.storeState.blocks[blockId];
        if (block.ast && block.ast.tables) {
          let joins = block.ast.tables.filter((a) => a.type === "join");
          if (joins) {
            for (let i = 0; i < joins.length; i++) {
              let join = joins[i];
              let left = block.ast.tables.find(
                (a) => a.type === "table" && a.alias === join.left.parent
              );
              let right = block.ast.tables.find(
                (a) => a.type === "table" && a.alias === join.right.parent
              );
              join.leftTable = left;
              join.rightTable = right;
              if (join.leftTable || join.rightTable)
                this.storeState.joinSuggestions.push(join);
            }
          }
        }
      }
    },
    getSoupSchedules(opts) {
      console.log("starting soup_get_schedules...", opts);
      const path = store.getPath("/soup_get_schedules");
      let d = {
        sessionId: this.storeState.sessionId,
        rowLimit: opts.rowLimit || this.storeState.maxBlocksToGet,
      };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log("done soup_get_schedules...", opts);
          self.storeState.schedules = res.data.data;
          self.storeState.gotSchedules = true;
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getOneBlockFromFlask() {
      console.log("getOneBlockFromFlask...");
      let curPath = this.$route.path;
      let blockId = this.$route.params.id;
      var path = store.getPath("/soup_get_block");
      if (curPath.startsWith("/data")) {
        path = store.getPath("/soup_get_public_block");
      }
      console.log(`${path} start: ${blockId}`);
      if (
        !curPath.startsWith("/run") &&
        !curPath.startsWith("/data") &&
        !curPath.startsWith("/form") &&
        !curPath.startsWith("/spot")
      )
        return;
      if (this.storeState.blocks[blockId]) {
        window.bus.$emit("doneGetOneBlockFromFlask", { blockId: blockId });
        return;
      }
      console.log(`${path} start2: ${blockId}`);
      let d = {
        sessionId: this.storeState.sessionId,
        blockId: blockId,
        route: curPath,
      };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log(`${path} done: ${res.data.ok}`);
          if (!res.data.ok) {
            self.storeState.gettingBlock = false;
            self.storeState.noAccess = true;
            return;
          }
          var block = res.data.data;
          // self.storeState.block = block
          if (!self.storeState.blocks[block.uuid])
            self.storeState.blocks[block.uuid] = block;
          window.bus.$emit("doneGetOneBlockFromFlask", { blockId: block.uuid });
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSoupBlocks(opts) {
      console.log("starting soup_get_blocks...", opts);
      const path = store.getPath("/soup_get_blocks");
      let d = {
        sessionId: this.storeState.sessionId,
        rowLimit: opts.rowLimit || this.storeState.maxBlocksToGet,
        trash: opts.trash || "false",
      };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log("done soup_get_blocks...", res);
          if (!res.data.ok) {
            this.goToRun();
            return;
          }
          if (self.storeState.block.uuid) {
            res.data.data[self.storeState.block.uuid] = self.storeState.block;
          }
          if (opts.trash) {
            self.storeState.trash = res.data.data;
            self.storeState.gettingTrash = false;
            return;
          }
          self.storeState.blocks = res.data.data;
          self.getOneBlockFromFlask();
          self.storeState.gotBlocks = true;
          if (opts.rowLimit === self.storeState.maxBlocksToGet)
            self.storeState.gotBlocks2 = true;
          self.storeState.snackbar = true;
          self.storeState.message = `Got blocks!`;
          self.storeState.blockTags = [];
          self.storeState.blockTagCounts = {};
          self.storeState.blockAuthorCounts = {};
          for (let [key, value] of Object.entries(self.storeState.blocks)) {
            let blockTagKeys = value.tags.map((t) => t.value);
            for (let itag = 0; itag < value.tags.length; itag++) {
              const tagKey = value.tags[itag];
              if (self.storeState.blockTagCounts[tagKey.text]) {
                self.storeState.blockTagCounts[tagKey.text] += 1;
              } else {
                self.storeState.blockTagCounts[tagKey.text] = 1;
              }
            }
            let allTagKeys = self.storeState.blockTags.map((t) => t.value);
            let newTags = _.difference(blockTagKeys, allTagKeys);
            if (newTags.length > 0 && newTags[0]) {
              for (let i = 0; i < newTags.length; i++) {
                self.storeState.blockTags.push(
                  value.tags.find((t) => t.value === newTags[i])
                );
              }
            }
            if (self.storeState.blockAuthorCounts[value.email]) {
              self.storeState.blockAuthorCounts[value.email] += 1;
            } else {
              self.storeState.blockAuthorCounts[value.email] = 1;
            }
          }
          self.storeState.authorList = [];
          for (let [key, value] of Object.entries(
            self.storeState.blockAuthorCounts
          )) {
            self.storeState.authorList.push({ text: key, ct: value });
          }
          self.storeState.authorList = self.storeState.authorList.sort(
            (a, b) => {
              return b.ct - a.ct;
            }
          );
          self.storeState.tagList = [];
          self.storeState.permissions = self.storeState.permissions.filter(
            (p) => !p.value.startsWith("tag.")
          );
          for (let [key, value] of Object.entries(
            self.storeState.blockTagCounts
          )) {
            self.storeState.tagList.push({ text: key, ct: value });
            let permission = `tag.${key.replace(/ /g, "_")}`;
            self.storeState.permissions.push({
              value: permission,
              path: false,
            });
          }
          self.storeState.tagList = self.storeState.tagList.sort((a, b) => {
            return b.ct - a.ct;
          });
          this.getTaggedModels(self);
          this.getJoinSuggestions(self.storeState.blocks);
          if (opts.rowLimit === self.storeState.firstBlockGetLimit) {
            this.getSoupBlocks({ rowLimit: this.storeState.maxBlocksToGet });
          }
          if (
            Object.keys(self.storeState.blocks).length === 0 &&
            self.storeState.settings.user.me.role != "restricted"
          ) {
            this.goToRun();
          }
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getUrlParams() {
      if (this.$route.query && this.$route.query.f) {
        if (this.$route.query.f === "getApiKey") {
          this.getApiKey();
        }
      }
    },
    getSoupSettings() {
      const path = store.getPath("/soup_get_settings");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.loading = false;
            self.storeState.settings = res.data.data;
            this.getUrlParams();
            if (res.data.data.user.me.email.includes("@seekwell.io")) {
              if (self.storeState.showDebugStuffNow)
                self.storeState.showDebugStuff = true;
              let hasSoup = self.cmdks.find((k) => k.cmd === "goToSoup");
              if (!hasSoup) {
                let soupCmdk = {
                  cmd: "goToSoup",
                  description: "Go to Soup",
                  icon: "mdi-launch",
                  search: "go,to,soup",
                  f: this.goToSoup,
                };
                self.cmdks.push(soupCmdk);
              }
            } else {
              if (window.Intercom) {
                window.Intercom("hide");
              } else {
                // console.log('window.Intercom: ', window.Intercom)
                // (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/nbdl7flf';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
              }

              window.Sentry.configureScope((scope) => {
                scope.setUser({ email: res.data.data.user.me.email });
              });
              window.analytics.identify(res.data.data.user.me.email, {
                email: res.data.data.user.me.email,
              });
              window.analytics.track(
                "Application Launched",
                this.storeState.defaultAnalyticsProps
              );
              console.log("Launched ", this.storeState.defaultAnalyticsProps);
            }
            if (res.data.data.user.me.role === "admin") {
              let updateUserRolesPermissions = {
                cmd: "updateUserRolesPermissions",
                description: "Update User Roles / Permissions",
                icon: "mdi-account-multiple-plus",
                search: "user,roles,permissions,team",
                children: function () {},
                f: this.updateUserRolesPermissions2,
              };
              self.cmdks.push(updateUserRolesPermissions);
            } else if (res.data.data.user.me.role === "restricted") {
              let curPath = this.$route.path;
              var allowed = false;
              var permissions = false;
              if (
                res.data.data.user.me.membership_details &&
                res.data.data.user.me.membership_details.permissions
              ) {
                permissions =
                  res.data.data.user.me.membership_details.permissions;
              }
              if (permissions && permissions.length > 0) {
                for (let index = 0; index < permissions.length; index++) {
                  const permission = permissions[index];
                  if (permission.path && curPath.startsWith(permission.path)) {
                    allowed = true;
                  }
                }
              }
              if (!allowed) {
                this.storeState.showHelp = true;
                this.$router
                  .push({ name: "Restricted", path: curPath })
                  .catch((err) => console.error(err));
              }
            }
          } else {
            console.error("getSoupSettings error: ", res.data);
            if (res.data.reason && res.data.reason === "badSessionId") {
              this.logout();
            }
          }
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSoupSources() {
      const path = store.getPath("/soup_get_sources");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      self.storeState.allSources = [];
      self.storeState.allSources.push({
        name: "Sheets / CSV / Block",
        uuid: "googlesheets",
        type: "sheets",
        meta: false,
        db_type: "SQLite3",
        spreadsheetId: false,
        sheets: [],
        unique_source: 1,
        block_uuid: "googlesheets",
      });
      axios
        .post(path, d)
        .then((res) => {
          if (!res.data.ok) {
            self.storeState.addingSource = true;
            return;
          }
          if (res.data.data.length === 0) {
            self.storeState.addingSource = true;
          }
          self.storeState.gotSources = true;
          self.storeState.allSources = res.data.data;
          self.storeState.allSources.push({
            name: "Sheets / CSV / Block",
            uuid: "googlesheets",
            type: "sheets",
            meta: false,
            db_type: "SQLite3",
            spreadsheetId: false,
            sheets: [],
            unique_source: 1,
            block_uuid: "googlesheets",
          });
          if (
            self.storeState.gotSfdc &&
            !self.storeState.allSources.find((s) => s.type === "sfdc")
          ) {
            self.storeState.allSources.push({
              name: "Salesforce",
              uuid: "sfdc",
              type: "sfdc",
              meta: false,
              db_type: "sfdc",
              unique_source: 1,
              block_uuid: "sfdc",
            });
          }
          store.saveToLocalStorage("seekwell_allSources", res.data.data);
          self.storeState.sources = res.data.data.filter(
            (o) => o.unique_source === 1
          );
          self.storeState.defaultSource = false;
          self.storeState.defaultSource = self.storeState.allSources.find(
            (s) => s.favorite
          );
          if (self.storeState.defaultSource) {
            self.getDefaultMetaData(self, self.storeState.defaultSource);
            store.saveToLocalStorage(
              "seekwell_defaultSource",
              self.storeState.defaultSource
            );
          } else if (self.storeState.allSources.length > 0) {
            self.storeState.defaultSource = self.storeState.allSources[0];
            self.getDefaultMetaData(self, self.storeState.defaultSource);
            store.saveToLocalStorage(
              "seekwell_defaultSource",
              self.storeState.defaultSource
            );
          }
          window.bus.$emit("doneGettingSources", { done: true });
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getDefaultMetaData(self, source) {
      console.log("getDefaultMetaData...", source);
      let curPath = this.$route.path;
      if (curPath.startsWith("/run")) return;
      let block = JSON.parse(JSON.stringify(self.storeState.blockTemplate));
      block.source = source;
      block.source.uuid = block.source.block_uuid;
      block.code = self.storeState.exploreSqlDict[source.db_type];
      block.destination = {};
      block.repeat = {};
      block.limit = 10000;
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
        rowLimit: self.storeState.exploreRowLimit,
      };
      self.storeState.gettingDbMeta = true;
      axios
        .post(store.getPathRunner("/run_one"), data)
        .then((res) => {
          self.storeState.gettingDbMeta = false;
          if (res.data.ok) {
            console.log("getDefaultMetaData done: ");
            self.storeState.snackbar = true;
            self.storeState.message = "Explore refreshed!";
            self.storeState.dbMeta = res.data;
            self.storeState.dbMeta.tables = [];
            self.storeState.dbMeta.schemas = [];
            self.storeState.dbMeta.schemaTables = [];
            let uniqueSchemas = [];
            self.storeState.dbMeta.tablesNoViews = [];
            if (self.storeState.dbMeta.df.length > 0)
              self.storeState.browsing.catalog =
                self.storeState.dbMeta.df[0].table_catalog;
            for (let i = 0; i < self.storeState.dbMeta.df.length; i++) {
              let meta = store.lowercaseObjKeys(self.storeState.dbMeta.df[i]);
              if (meta.table_schema) {
                var table = `${meta.table_schema}.${meta.table_name}`;
              } else {
                var table = `${meta.table_name}`;
              }
              if (
                !self.storeState.dbMeta.tables.includes(table) &&
                meta.table_schema != "information_schema"
              ) {
                self.storeState.dbMeta.tables.push(table);
                self.storeState.dbMeta.schemaTables.push({
                  name: meta.table_name,
                  schema: meta.table_schema,
                  showMore: false,
                });
              }
              if (
                !uniqueSchemas.includes(meta.table_schema) &&
                meta.table_schema != "information_schema"
              ) {
                self.storeState.dbMeta.schemas.push({
                  name: meta.table_schema,
                  showMore: false,
                });
                uniqueSchemas.push(meta.table_schema);
              }
              if (
                !self.storeState.dbMeta.tablesNoViews.includes(table) &&
                meta.table_schema != "information_schema" &&
                meta.is_table > 0
              ) {
                self.storeState.dbMeta.tablesNoViews.push(table);
              }
            }
            if (source.importDb) {
              self.storeState.autoImport.tables = JSON.parse(
                JSON.stringify(self.storeState.dbMeta.schemaTables)
              );
              for (
                let index = 0;
                index < self.storeState.autoImport.tables.length;
                index++
              ) {
                let table = self.storeState.autoImport.tables[index];
                table.include = false;
                table.success = false;
                table.destName = table.name;
                Vue.set(self.storeState.autoImport.tables, index, table);
              }
              self.storeState.autoImport.gettingTables = false;
              self.$forceUpdate();
            }
          } else {
            console.error("getDefaultMetaData error: ", res.data);
            self.savingSource = false;
            self.storeState.snackbar = true;
            self.storeState.message = res.data.error;
            self.connectError = res.data.error;
          }
        })
        .catch((error) => {
          console.error("getDefaultMetaData error", error);
          self.savingSource = false;
          self.storeState.snackbar = true;
          self.storeState.message = error;
        });
    },
    getWorkbooks() {
      this.storeState.gotWorkbooks = false;
      const path = store.getPath("/soup_get_workbooks");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          window.bus.$emit("getWorkbooks", { done: true });
          if (res.data.ok) {
            this.storeState.gotWorkbooks = true;
            self.storeState.destinations.workbooks = res.data.data.value;
          } else {
            self.storeState.gotWorkbooks = false;
            // let url =
            // window.location.href = 'https://seekwell.io/web_auth_sheets'
            // var win = window.open(url, '_blank');
          }
        })
        .catch((error) => {
          self.storeState.gotSheets = false;
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getGoogleDriveWorkbooks() {
      this.storeState.gotWorkbooks = false;
      const path = store.getPath("/soup_get_gd_workbooks");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          window.bus.$emit("getGoogleDriveWorkbooks", { done: true });
          if (res.data.ok) {
            this.storeState.gotWorkbooks = true;
            self.storeState.destinations.gdWorkbooks = res.data.files;
          } else {
            self.storeState.gotWorkbooks = false;
            // let url =
            // window.location.href = 'https://seekwell.io/web_auth_sheets'
            // var win = window.open(url, '_blank');
          }
        })
        .catch((error) => {
          self.storeState.gotSheets = false;
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSoupSheets() {
      const path = store.getPath("/soup_get_destinations");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          window.bus.$emit("getSoupSheets", { done: true });
          self.storeState.gotSheets = true;
          if (res.data.ok) {
            self.storeState.destinations.spreadSheets = res.data.spreadSheets;
          } else {
            self.storeState.gotSheets = false;
            // let url =
            // window.location.href = 'https://seekwell.io/web_auth_sheets'
            // var win = window.open(url, '_blank');
          }
        })
        .catch((error) => {
          self.storeState.gotSheets = false;
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    getSoupApps() {
      const path = store.getPath("/soup_get_app_destinations");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      self.storeState.gotApps = false;
      axios
        .post(path, d)
        .then((res) => {
          console.log("soup_get_app_destinations: ", res.data);
          self.storeState.gotApps = true;
          if (res.data.ok) {
            self.storeState.integrations = res.data;
            if (
              self.storeState.integrations.blueshift &&
              self.storeState.integrations.blueshift.ok
            ) {
              let d = {
                icon: "mdi-alpha-b-circle-outline",
                text: "Blueshift",
                value: "blueshift",
                story: false,
              };
              self.storeState.destinationTypes.push(d);
            }
            if (
              self.storeState.integrations.gainsight &&
              self.storeState.integrations.gainsight.ok
            ) {
              let d = {
                icon: "mdi-alpha-g-circle-outline",
                text: "Gainsight",
                value: "gainsight",
                story: false,
              };
              self.storeState.destinationTypes.push(d);
            }
            if (
              self.storeState.integrations.customerio &&
              self.storeState.integrations.customerio.ok
            ) {
              let d = {
                icon: "mdi-account-circle-outline",
                text: "Customerio",
                value: "customerio",
                story: false,
              };
              self.storeState.destinationTypes.push(d);
            }
            if (
              self.storeState.integrations.activecampaign &&
              self.storeState.integrations.activecampaign.ok
            ) {
              let d = {
                icon: "mdi-chevron-double-right",
                text: "ActiveCampaign",
                value: "activecampaign",
                story: false,
              };
              self.storeState.destinationTypes.push(d);
            }
            if (self.storeState.integrations.facebook) {
              let d = {
                icon: "mdi-facebook",
                text: "Facebook",
                value: "facebook",
                story: false,
              };
              self.storeState.destinationTypes.push(d);
            }
            if (
              self.storeState.integrations.close &&
              self.storeState.integrations.close.ok
            ) {
              let d = {
                icon: "mdi-checkbox-blank-circle-outline",
                text: "Close",
                value: "close",
                story: false,
              };
              self.storeState.destinationTypes.push(d);
            }
            if (
              self.storeState.integrations.zoho &&
              self.storeState.integrations.zoho.ok
            ) {
              self.storeState.destinations.zoho = res.data.zoho;
            }
            if (
              self.storeState.integrations.hubspot &&
              self.storeState.integrations.hubspot.ok
            ) {
              self.storeState.destinations.hubspot = res.data.hubspot;
            }
          }
        })
        .catch((error) => {
          self.storeState.gotApps = true;
          console.error(error);
        });
    },
    getSoupIntercom() {
      const path = store.getPath("/soup_get_intercom_data");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.gotIntercom = true;
            self.storeState.destinations.intercom = res.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoupZoho() {
      const path = store.getPath("/soup_get_zoho_data");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.gotZoho = true;
            self.storeState.destinations.zoho = res.data.zoho;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoupCloseFields() {
      this.storeState.gettingSfdc = true;
      const path = store.getPath("/soup_get_close_fields");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          console.log("soup_get_close_fields: ", res.data);
          if (!res.data.ok) {
            return;
          } else if (res.data.ok) {
            console.log("soup_get_close_fields in lead ", res.data.lead);
            self.storeState.destinations.close.lead = res.data.lead;
            console.log(
              "soup_get_close_fields in okat true ",
              self.storeState.destinations.close.lead
            );
            self.storeState.destinations.close.contact = res.data.contact;
            self.storeState.destinations.close.opportunity =
              res.data.opportunity;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoupHubspot() {
      const path = store.getPath("/soup_get_hubspot_data");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.gotHubspot = true;
            self.storeState.destinations.hubspot = res.data.hubspot;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoupSfdcMetadata(opts) {
      this.storeState.gettingSfdc = true;
      const path = store.getPath("/soup_get_sfdc_metadata");
      let d = { sessionId: this.storeState.sessionId, opts: opts };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          this.storeState.gettingSfdc = false;
          if (opts.all) this.storeState.gotAllSfdc = true;
          if (!res.data.ok) {
            return;
          }
          if (opts.one && res.data.metadata[opts.object]) {
            console.log("soup_get_sfdc_metadata on: ", res.data.metadata);
            this.storeState.sfdcMetadata[opts.object] =
              res.data.metadata[opts.object];
            return;
          } else if (res.data.ok) {
            console.log("soup_get_sfdc_metadata: ", res.data.metadata);
            this.storeState.sfdcMetadata = res.data.metadata;
          }
        })
        .catch((error) => {
          this.storeState.gettingSfdc = false;
          console.error(error);
        });
    },
    getSoupSfdc() {
      const path = store.getPath("/soup_get_sfdc");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.gotSfdc = true;
            self.storeState.destinations.sfdc = res.data;
            self.storeState.allSources.push({
              name: "Salesforce",
              uuid: "sfdc",
              type: "sfdc",
              meta: false,
              db_type: "sfdc",
              unique_source: 1,
              block_uuid: "sfdc",
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoupSlack() {
      const path = store.getPath("/soup_get_slack_channels");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;
      axios
        .post(path, d)
        .then((res) => {
          if (res.data.ok) {
            self.storeState.destinations.slack = res.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    sqlGetValStr(row, cols) {
      var vals = "";
      for (let i = 0; i < cols.length; i++) {
        let val = row[cols[i]];
        vals += `"${val}", `;
      }
      return vals.slice(0, vals.length - 2);
    },
    initSqlStore(table, colLs, drop) {
      function errorHandler(transaction, error) {
        console.log("Error : " + error.message);
      }
      function successHandler(a, b) {
        console.log("sucess");
      }
      if (drop) {
        this.storeState.db.transaction(function (tx) {
          tx.executeSql(
            `DROP TABLE IF EXISTS ${table}`,
            [],
            successHandler,
            errorHandler
          );
        });
      }
      this.storeState.db.transaction(function (tx) {
        tx.executeSql(
          `CREATE VIRTUAL TABLE IF NOT EXISTS ${table} USING fts3(${colLs}, tokenize=simple)`,
          [],
          successHandler,
          errorHandler
        );
      });
    },
    initWebSql(data, table) {
      var self = this;
      var cols = Object.keys(data[0]);
      var colLs = "";
      for (let i = 0; i < cols.length; i++) {
        colLs += cols[i] + ", ";
      }
      colLs = colLs.slice(0, colLs.length - 2);
      function errorHandler(transaction, error) {
        console.error("Error : " + transaction);
        console.error("Error : " + error.message);
      }
      function successHandler(a, b) {
        console.log("sucess");
      }
      if (this.storeState.refreshDb) {
        this.storeState.db.transaction(function (tx) {
          tx.executeSql(
            `DROP TABLE IF EXISTS ${table}`,
            [],
            successHandler,
            errorHandler
          );
          tx.executeSql(
            `CREATE VIRTUAL TABLE IF NOT EXISTS ${table} USING fts3(${colLs}, tokenize=simple)`,
            [],
            successHandler,
            errorHandler
          );
          for (let i = 0; i < data.length; i++) {
            let el = data[i];
            let valStr = self.sqlGetValStr(el, cols);
            tx.executeSql(
              `INSERT INTO ${table} (${colLs}) VALUES (${valStr})`,
              [],
              successHandler,
              errorHandler
            );
          }
        });
      } else {
        console.warn(
          "this.storeState.refreshDb === true, not updating webSql DB"
        );
      }
    },
    updateSettings() {
      let self = this;
      let d = {
        sessionId: this.storeState.sessionId,
        settings: this.storeState.settings,
      };
      let path = store.getPath("/soup_update_settings");
      axios
        .post(path, d)
        .then((res) => {
          console.log(`updated ${path}`, res.data);
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    updateEditableDetails(detail_id, detail_type) {
      let self = this;
      let d = {
        sessionId: this.storeState.sessionId,
        detail_id: detail_id,
        detail_type: detail_type,
        details: this.editableDetails,
      };
      this.storeState.editableDetailsAll[`${detail_type}-${detail_id}`] =
        this.editableDetails;
      let path = store.getPath("/soup_update_details");

      axios
        .post(path, d)
        .then((res) => {
          console.log(`updated ${path}`, res.data);
        })
        .catch((error) => {
          this.storeState.snackbar = true;
          this.storeState.message = error;
          console.error(error);
        });
    },
    cmdkClick(e) {
      console.log("cmdkClick: ", e);
      var self = this;
      if (e.currentTarget.id) {
        var cmd = self.cmdkFiltered.find((o) => o.cmd === e.currentTarget.id);
        console.log("cmd: ", cmd);
        if (cmd.parent && cmd.parent === "addReminder") {
          console.log("got reminder...", cmd);
          let c = cmd.cmd.replace("cmdkItem_", "");
          self.storeState.editableDetails.reminder = cmd.f();
          // store.insertSqlStore(self.storeState.details.email, 'users', {reminder: self.storeState.details.reminder})

          self.$children.find((o) => o.$el.id === "details").$forceUpdate();
          self.changeFocus("details", this);
          self.storeState.cmdkActive = false;
        } else {
          console.log("cmd: ", cmd);
          cmd.f(cmd);
        }
        if (!cmd.children) self.storeState.cmdkActive = false;
      }
    },
    cmdkOnKey(e) {
      if (![13, 40, 38].includes(e.keyCode)) this.storeState.searchIndex = 0;
      // console.log('cmdkOnKey: ', e)
    },
    goBack() {
      let curPath = this.$route.path;
      if (curPath.startsWith("/queues")) {
        this.$router.push({ path: "/search" }).catch((err) => {});
      } else if (curPath.startsWith("/run")) {
        this.$router.push({ path: "/blocks" }).catch((err) => {});
      } else if (curPath.startsWith("/form")) {
        this.$router.push({ path: "/blocks" }).catch((err) => {});
      } else if (curPath.startsWith("/blocks")) {
        this.$router.push({ path: "/blocks" }).catch((err) => {});
      } else if (curPath.startsWith("/search")) {
        this.$router.push({ path: "/" }).catch((err) => {});
      } else if (curPath != "/") {
        this.$router.go(-1);
      }
    },
    handleS(e) {
      console.log("handle cmd+s..", e);
      let curPath = this.$route.path;
      if (curPath.startsWith("/run") && !this.storeState.block.favorite) {
        this.storeState.block.favorite = true;
        let self = this;
        setTimeout(() => {
          let c = self.$children.find((c) => c.$refs.run);
          if (c && c.$refs && c.$refs.title) c.$refs.title.focus();
        }, 0);
      }
    },
    handleEsc(e) {
      console.log("handle esc..", e);
      this.storeState.addingTag = false;
      this.storeState.searching = false;
      this.storeState.searchTerm = "";
      let blocks = this.$children.find((c) => c.$refs.blocks);
      if (blocks && blocks.$refs.blockSearch) blocks.$refs.blockSearch.blur();
      if ([2, 3].includes(this.storeState.viewNumber)) {
        this.storeState.viewNumber = 1;
        return;
      }
      if (this.storeState.blockListOpen) {
        this.storeState.blockListOpen = false;
        return;
      }
      this.storeState.viewNumber = 1;
      if (this.storeState.showSuggestions) {
        this.storeState.showSuggestions = false;
        this.storeState.searchIndex = -1;
        // window.bus.$emit('hideSuggestions')
        return;
      }
      if (this.storeState.currentFocus === "cmdk") {
        this.storeState.currentFocus = "main";
        return;
      }
      if (this.storeState.currentFocus === "code") {
        let c = this.$children.find((c) => c.$refs.run);
        c.$refs.runBtn.focus();
        c.$refs.runBtn.blur();
        return;
      }
      if (
        ["INPUT", "TEXTAREA"].includes(document.activeElement.tagName) &&
        this.storeState.tagActive
      ) {
        document.activeElement.blur();
        this.storeState.tagActive = false;
        return;
      }
      if (this.storeState.justClosedCmdk) {
        this.closeCmdk();
        return;
      }
      this.goBack();
      if (e && e.preventDefault) e.preventDefault();
    },
    onClick(e) {
      // console.log('click', e)
      this.storeState.showSuggestions = false;
      this.storeState.searchIndex = -1;
    },
    getTeamsChallens() {
      const path = store.getPath("/soup_get_msteams_channels");
      let d = { sessionId: this.storeState.sessionId };
      var self = this;

      axios
        .post(path, d)
        .then((res) => {
          console.log("getTeamsChallens: ", res.data);
          if (res.data.ok) {
            self.storeState.destinations.msteams = res.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSoupDriftFields() {
      const path = store.getPath("/soup_get_drift_fields");
      let d = { sessionId: this.storeState.sessionId };
      axios
        .post(path, d)
        .then((res) => {
          if (!res.data.ok) {
            return;
          } else {
            console.log("soup_drift_fields: ", res.data);
            this.storeState.destinations.drift.contacts = res.data.drift;
            this.storeState.gotDriftFields = true;
          }
        })
        .catch((error) => {
          this.storeState.gotDriftFields = false;
          console.error(error);
        });
    },
    startSoup() {
      // self.initSqlStore('store', ['id', 'category', 'details'], false)
      // axios.post(path, d)
      //   .then((res) => {
      //     console.log('got getUserData: ', res.data)
      //     self.storeState.loading = false
      //     if (res.data.ok) {
      //       // this.model.users = res.data[0].data
      //       // self.storeState.dataModel.users = res.data[0].details.data
      //       for (let i = 0; i < Object.keys(res.data.data).length; i++) {
      //         let el = Object.keys(res.data.data)[i];
      //         console.log('updating: ', el, res.data.data[el].details.data.length)
      //         // self.initWebSql(res.data.data[el].details.data, el)
      //       }
      //     }
      //   })
      //   .catch((error) => {
      //     this.storeState.snackbar = true;
      //     this.storeState.message = error;
      //     console.error(error);
      //   });
    },
  },
  computed: {
    runTimes: function () {
      let mins = _.range(0, 59, 5);
      let hours = _.range(0, 23, 1);
      let times = [];

      for (let i = 0; i < hours.length; i++) {
        let hour = hours[i];
        for (let i = 0; i < mins.length; i++) {
          times.push(
            `${_.padStart(hour, 2, "0")}:${_.padStart(mins[i], 2, "0")}`
          );
        }
      }
      return times;
    },
    dbDestinations: function () {
      let result = [];
      let uniqueNickNames = [];
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i];
        if (
          !uniqueNickNames.includes(source.name) &&
          !["airtable", "sfdc", "SQLite3"].includes(source.db_type)
        ) {
          uniqueNickNames.push(source.name);
          result.push(source);
        }
      }
      // result = result.concat(this.storeState.sets)
      return result;
    },
    renderedSnippet() {
      let block = this.storeState.cmdkForm;
      var snippet = "";
      if (block.params) {
        let params = {};
        for (let i = 0; i < block.params.length; i++) {
          params[block.params[i].name] = block.params[i].value;
        }
        snippet = store.interpolate(block.code)(params);
      } else {
        snippet = block.code;
      }
      return snippet;
    },
    cmdkFiltered: function () {
      let searchTerm = this.storeState.cmdkInput.trim();
      var self = this;
      var curPath = this.$route.path;
      if (curPath === "/") curPath = "main";
      if (curPath.includes("/")) curPath = curPath.split("/")[1];
      var cmdks = self.cmdks;
      if (self.storeState.cmdkParentCmd) {
        let p = self.cmdks.find(
          (item) => item.cmd === self.storeState.cmdkParentCmd
        );
        if (p) {
          var children = p.children();
          if (!children || children.length === 0) return [];
          if (children.length === 1) return children;
          cmdks = children;
        }
      }
      function atLeastOneStartsWith(cmdk, searchTerm) {
        let searchTermLs = searchTerm.split(" ");
        let searchInLs = cmdk.search.split(",");
        let hasOne = false;
        let numOfTerms = searchTermLs.length;
        let numOfMatching = 0;
        for (let i = 0; i < searchTermLs.length; i++) {
          for (let i2 = 0; i2 < searchInLs.length; i2++) {
            if (searchInLs[i2].toLowerCase().startsWith(searchTermLs[i])) {
              numOfMatching += 1;
              hasOne = true;
            }
          }
        }
        if (
          cmdk.parent === "useSnippet" &&
          cmdk.search.toLowerCase().includes(searchTerm.toLowerCase())
        )
          hasOne = true;
        return {
          hasOne: hasOne,
          numOfMatching: numOfMatching,
          numOfTerms: numOfTerms,
        };
      }
      let cmdksFilteredAndSorted = [];
      if (cmdks && !cmdks[0].search) return cmdks;
      for (let i = 0; i < cmdks.length; i++) {
        let cmdk = cmdks[i];
        let searchIn = cmdk.search.replace(",", " ");
        let matches = atLeastOneStartsWith(cmdk, searchTerm);
        if (cmdk.focus && cmdk.focus != curPath.replace("/", "")) {
          cmdk.score = 0;
        } else if (searchTerm === "") {
          cmdk.score = 100;
          cmdksFilteredAndSorted.push(cmdk);
        } else if (!matches.hasOne) {
          cmdk.score = 0;
        } else {
          cmdk.score = fuzz.token_set_ratio(
            searchTerm,
            cmdk.search.replace(",", " ")
          );
          cmdk.score =
            cmdk.score * (matches.numOfMatching / matches.numOfTerms);
          if (cmdk.score > 0 || matches.hasOne) {
            cmdksFilteredAndSorted.push(cmdk);
          }
        }
      }
      return cmdksFilteredAndSorted.sort(this.compareValues("score", "desc"));
    },
  },
};
</script>

<style>
* {
  text-transform: none !important;
}

html {
  overscroll-behavior-x: none;
}
.search-text {
  height: 38px;
  font-size: 1.25rem;
  outline: none;
  width: 100%;
}
.table-title {
  font-size: 1.25rem;
  font-weight: 700;
}
.theme--light {
  color: #212529 !important;
}
.sw-green {
  color: #19774d !important;
}
*:focus {
  outline: 0;
}
#app {
  min-height: 100vh;
  margin: 0;
}
.cmdkInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.logout {
  margin-left: 20px;
}
.key {
  background: #797979;
  border-radius: 3px;
  display: inline-block;
  max-height: 18px;
  min-width: 19px;
  margin-left: 4px;
  padding: 1px 5px 5px 5px;
  text-align: center;
  position: relative;
  top: 3px;
  flex: 0 0 auto;
}
.key-inner {
  color: #fff;
  font-size: 12px;
  line-height: 12px;
  font-weight: normal;
  letter-spacing: 0.005em;
  -webkit-font-smoothing: antialiased;
  position: relative;
  top: -4px;
  font-weight: bold;
}
.key-inner-icon {
  top: -5px;
}
.key-inner-cmdk {
  color: #fff;
  font-size: 12px;
  line-height: 12px;
  font-weight: normal;
  letter-spacing: 0.005em;
  -webkit-font-smoothing: antialiased;
  position: relative;
  top: -6px;
  font-weight: bold;
}
.key-inner-icon-cmdk {
  top: -6px;
}
.cmdk-row {
  color: #212529;
  font-size: 16px;
  margin-top: 5px !important;
  margin-right: 5px !important;
  margin-left: 20px !important;
}
.cmdk-active {
  background-color: #eee;
}
.cmdk-hover:hover {
  background-color: #eee;
}
.cmdk-input {
  margin-top: 5px !important;
  margin-right: 5px !important;
  margin-left: 20px !important;
}
.red {
  color: #eb5757 !important;
}
.trial-expired {
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #fff !important;
  background-color: #eb5757 !important;
  cursor: pointer;
  left: 33%;
}
.grey50 {
  color: rgba(0, 0, 0, 0.5);
}
.header-icon {
  /* float: right; */
}
.clickable {
  cursor: pointer;
}
.key-icon {
  float: right;
}
.v-data-table th {
  font-size: 14px !important;
  text-align: left;
}
.v-data-table--fixed-header thead th {
  border-top: solid 1px rgba(0, 0, 0, 0.12);
  border-left: solid 1px rgba(0, 0, 0, 0.12);
  border-right: solid 1px rgba(0, 0, 0, 0.12);
  /* background-color: #CBD2D9 !important; */
  background: #f5f7fa !important;
  font-weight: 700;
  z-index: 0;
}
.v-data-table--fixed-header td {
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
  border-left: solid 1px rgba(0, 0, 0, 0.12);
  border-right: solid 1px rgba(0, 0, 0, 0.12);
}
.v-data-table {
  font-size: 14px;
}
.v-data-table-header th.sortable .v-data-table-header__icon {
  margin-left: 5px;
}
.v-data-footer__select {
  padding-right: 10px;
}
.v-data-footer__pagination {
  margin-top: 1px;
}
.v-data-footer__select .v-select__selections .v-select__selection--comma {
  padding-left: 4px;
  padding-bottom: 3px;
}
.v-navigation-drawer {
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 16px 45px rgba(0, 0, 0, 0.05),
    0 0 0.5px rgba(0, 0, 0, 0.1) !important;
  transition: box-shadow 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  transition-property: box-shadow !important;
  transition-duration: 0.4s !important;
  transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  transition-delay: 0s !important;
}
.query-filters {
  position: absolute;
  right: 0px;
  z-index: 4;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  max-width: 1000px;
  width: 100vw;
  background-color: #fff;
}
th {
  white-space: nowrap;
}
.doc-title-container {
  padding-top: 1rem;
  padding-left: 2rem;
}
.grid-container {
  padding-top: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 3rem;
}
.grid-inner {
  width: 100%;
  height: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
}
.grid-inner:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.25);
}
.table-grid-inner {
  width: 100%;
  height: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  padding-top: 1rem;
}
.table-grid-inner:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.25);
}
.vert-horiz-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text__highlight {
  background: inherit !important;
  border-radius: 0px !important;
}
mark {
  color: #333;
  font-weight: 600;
  background-color: inherit !important;
  padding: 0px !important;
}
.v-menu__content {
  background-color: #fff;
}
.add-viz-search-container {
  padding-bottom: 1rem;
}
.add-viz-button-container {
  float: right;
  padding-right: 1rem;
  padding-top: 0.5rem;
}
.add-chart-row {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 2rem;
}
.add-chart-row:hover {
  background-color: #eee;
}
.add-chart {
  height: 300px;
  padding-top: 1rem;
  padding-bottom: 2rem;
}
.grid-chart {
  height: 300px;
  padding-top: 1rem;
  padding-bottom: 2rem;
}
.hover-grey {
}
.hover-grey:hover {
  background-color: #eee;
  border-radius: 3px;
}
.viz-header-edit {
  float: right;
}
.vue-grid-item.vue-grid-placeholder {
  background-color: #50a779 !important;
}
.v-navigation-drawer--absolute {
  z-index: 4 !important;
}
.v-overlay--active {
  z-index: 3 !important;
}
.editor p.is-editor-empty:first-child::before {
  content: attr(data-empty-text);
  float: left;
  color: #aaa;
  pointer-events: none;
  height: 0;
  font-weight: 700;
}
.story-suggestions {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 5px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  -webkit-transition: opacity 0.2s, visibility 0.2s;
  transition: opacity 0.2s, visibility 0.2s;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  z-index: 2;
}

.menububble {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  padding: 0.3rem;
  margin-bottom: 0.5rem;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  visibility: hidden;
  opacity: 0;
  -webkit-transition: opacity 0.2s, visibility 0.2s;
  transition: opacity 0.2s, visibility 0.2s;
}

.menububble.is-active {
  visibility: visible;
  opacity: 1;
}

.menububble > button {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.story-suggestions-active {
  visibility: visible;
  opacity: 1;
}
.story-suggestion-overlay {
  position: absolute;
  color: #999;
  background-color: #fff;
  z-index: 2;
}
.story-suggestion-row {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 2px;
}
.story-suggestion-row-hover:hover {
  background-color: #eee;
  /* border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px; */
}
.story-suggestion-row-active {
  background-color: #eee;
}
.datatag {
  background-color: rgba(80, 167, 121, 0.4);
  font-weight: 700;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-radius: 3px;
}
.show-hide-destination {
  margin-bottom: 1.5rem;
  margin-top: -1rem;
}
.v-snack__content .v-btn__content {
  margin: -2px;
  color: #fff;
}
.story-result-container {
  padding-top: 5rem;
  padding-left: 6rem;
}
.story-html {
  border-left: solid;
  border-left-color: black;
  border-radius: 3px;
  padding-left: 1rem;
}
.story-tile {
  padding-left: 1rem;
}
.viz-header-container {
  padding-bottom: 1rem;
}
.dest-email {
  padding: 2px;
}
.get-help {
  position: fixed;
  bottom: 0;
  right: 0;
  padding-right: 1rem;
  padding-bottom: 1rem;
  z-index: 9;
}
.help-container {
  position: fixed;
  bottom: 80px;
  right: 0;
  margin-right: 1rem;
  width: 300px;
  z-index: 2;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 2px 12px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
}

.help-row {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  cursor: pointer;
}
.help-row:hover {
  background-color: #eee;
}
#intercom-container {
  display: none !important;
}
.intercom-lightweight-app {
  display: none !important;
}

.whitelist-error {
  color: #eb5757;
  font-weight: 700;
}
.run-timer {
  width: 2rem;
  display: inline-block;
  font-weight: 700;
}
.cursor-ns {
  cursor: ns-resize;
}
.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px;
}
.v-snack__content {
  white-space: pre-wrap;
}
.cmdk-row-container {
  cursor: pointer;
}
.pulse-spinner {
  transform: scale(1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.pulse-grid {
  transform: scale(1);
  animation: pulseGrid 2s infinite;
}

@keyframes pulseGrid {
  0% {
    box-shadow: 0 0 0 0 rgba(80, 167, 121, 1);
  }

  70% {
    box-shadow: 0 0 0 0.5rem rgba(80, 167, 121, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(80, 167, 121, 0);
  }
}

.CodeMirror-gutters {
  border-right: none !important;
  background-color: #fff !important;
  z-index: 0 !important;
}
.CodeMirror-gutter-wrapper {
  /* margin-left: -10px; */
}
.CodeMirror-linenumber {
  color: var(--cm-line-number-color) !important;
  /* display: var(--cm-gutter-display) !important; */
}
.CodeMirror-line {
  padding-left: 0.5rem !important;
}
.CodeMirror-placeholder {
  padding-left: 0.5rem !important;
}
.v-chip--select {
  margin: 0 !important;
  padding-left: 0px;
}
.v-chip {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.v-select .v-chip {
  margin: 0;
  margin-right: 1rem !important;
  margin-bottom: 14px;
}
.v-select.v-select--chips .v-select__selections {
  min-height: 40px;
}
.theme--light.v-chip:not(.v-chip--active) {
  background: none;
  margin-left: 1rem;
}
.theme--light.v-chip {
  background: transparent !important;
  border: none !important;
}
.theme--light.v-chip:hover {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  font-weight: bold !important;
}
.v-chip:before {
  background: transparent !important;
}
.v-chip__close.v-icon.v-icon--right {
  color: #fff !important;
  display: none;
}
.v-chip:hover .v-chip__close.v-icon.v-icon--right {
  color: #333 !important;
  display: inline-block;
  margin-top: -4px;
  margin-left: 4px;
}
.v-chip__content {
  /* font-weight: 700; */
}
.v-chip .v-avatar--right,
.v-chip .v-icon--right {
  margin-left: 5px;
}
textarea {
  resize: none !important;
}
.v-overlay--active {
  z-index: 100 !important;
}
.v-icon.v-icon {
  line-height: inherit !important;
  padding: 0;
}
.v-icon.v-icon::before {
  background-color: transparent !important;
}
.docs-td {
  border: none !important;
}
.double-curly-param {
  font-weight: 900;
}
</style>


